<template>
    <div>
        <!-- page loader -->
        <div v-if="pageLoading">
            <div id="page-section-loading" :class="['fade-out', { hide: !showLoader }]">
                <div id="loading-container">
                    <img id="loading-image" src="../assets/images/LifeChain_Logo.png" alt="Loading Image" :class="['fade-in', { show: loadingImageIsVisible }]" >
                    <div id="loading-text" :class="['fade-in-fast', { show: loadingTextIsVisible }]">
                        <!-- loading spinner -->
                        <div id="page-data-loading">
                            <div class="lds-facebook"><div></div><div></div><div></div></div>
                            <!-- <div>{{ loadingText }}</div> -->
                            <!-- <div>Loading...</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- page content -->
        <div id="page-section">
            <link rel="canonical" href="https://getbootstrap.com/docs/5.1/examples/dashboard/">
            <link href="../assets/dist/css/bootstrap.min.css" rel="stylesheet">

            <!-- half lock faded zoom-->
            <!-- <img id="lock-image" src="../assets/images/lock-half-faded-zoom.png" />      -->

            <!-- Vitrafy logo (bottom right) -->
            <!-- <img id="vitrafy-logo" style="position: fixed; height: 50px; right:27px; bottom: 39px;" src="../assets/images/vitrafy-logo-black.png"/>  -->

            <!-- header -->        
            <header class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 page-header" style="position: fixed; top: 0; width: 100%; height: 56px; background-color: #333 !important; box-shadow: none !important;">

                <!-- app menu -->
                <div style="position: absolute; top:8px; left:20px; z-index: 999;">

                    <b-dropdown menu-class="app-menu" toggle-class="text-decoration-none app-menu__toggle p-0 border-0" right no-caret>
                        <template #button-content class="header-user-icon">
                            <img class="app-menu__icon" style="" src="../assets/images/appMenu.png" />
                        </template>
                        <b-dropdown-item class="app-menu-item" @click="changeApp('home')">
                            <div style="background-color: #e9ecef; z-index: 2; border: 1px solid #bcbbbb; width: 34px; height: 34px; position: absolute; top: 11px; left: 15px; border-radius: 6px;">
                                <svg style="position: absolute; top: 4px; right: 4px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1j7ic9j" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z"></path></svg>
                            </div>
                            Home
                        </b-dropdown-item>
                        <b-dropdown-item class="app-menu-item" @click="changeApp('lifelink')">
                            <div style="background-color: #daf7ee; z-index: 2; border: 1px solid #47d7ac; width: 34px; height: 34px; position: absolute; top: 11px; left: 15px; border-radius: 6px;">
                                <svg style="position: absolute; top: 4px; right: 4px;" focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1eeojez" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>
                            </div>
                            LifeLink
                        </b-dropdown-item>
                        <b-dropdown-item class="app-menu-item" @click="changeApp('workflow')">
                            <div style="background-color: #fbfdfe; z-index: 2; border: 1px solid #4299e199; width: 34px; height: 34px; position: absolute; top: 11px; left: 15px; border-radius: 6px;">
                                <svg style="position: absolute; top: 4px; right: 4px;" focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1n5gron" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="currentColor"><path d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"></path></svg>
                            </div>
                            Workflow
                        </b-dropdown-item>                        
                    </b-dropdown>

                </div>

                <!-- Nav dynaic app name and icon -->
                <div v-if="selectedApp == 'home'" style="position: absolute;left: 88px; display: flex; justify-content: center; align-items: center;">
                    <div style="background-color: #e9ecef; z-index: 2; border: 1px solid #bcbbbb; width: 34px; height: 34px; position: absolute; top: -4px; left: 15px; border-radius: 6px;">
                        <svg style="position: absolute; top: 4px; right: 4px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1j7ic9j" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z"></path></svg>
                    </div>
                    <div style="color: #fff; margin-left: 62px; font-size: 16px;">Home</div>
                </div>        
                <div v-if="selectedApp == 'lifelink'" style="position: absolute;left: 88px; display: flex; justify-content: center; align-items: center;">
                    <div style="background-color: #daf7ee; z-index: 2; border: 1px solid #47d7ac; width: 34px; height: 34px; position: absolute; top: -4px; left: 15px; border-radius: 6px;">
                        <svg style="position: absolute; top: 4px; right: 4px;" focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1eeojez" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>
                    </div>
                    <div style="color: #fff; margin-left: 62px; font-size: 16px;">LifeLink</div>
                </div>
                <div v-if="selectedApp == 'workflow'" style="position: absolute;left: 88px; display: flex; justify-content: center; align-items: center;">
                    <div style="background-color: #fbfdfe; z-index: 2; border: 1px solid #4299e199; width: 34px; height: 34px; position: absolute; top: -4px; left: 15px; border-radius: 6px;">
                        <svg style="position: absolute; top: 4px; right: 4px;" focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1n5gron" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="currentColor"><path d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"></path></svg>
                    </div>
                    <div style="color: #fff; margin-left: 62px; font-size: 16px;">Workflow</div>
                </div>                     
                

                <!-- header LifeChain logo -->
                <div style="width: 100%; position: absolute; top: 11px; text-align: center;">
                     <!-- <img style="height: 34px;" src="../assets/images/life-chain_Logo.webp" /> -->
                    <img style="height: 34px;" src="../assets/images/LifeChain_Logo_Inverted.png" />
                </div>

                <div class="col-md-9 ms-sm-auto col-lg-10 px-md-4 nav-buttons">

                    <!-- mobile nav button -->
                    <button id="mobile-nav-button" class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation" style="top: -54px; right: 6px; border: none;">
                        <span class="navbar-toggler-icon" @click="openNav()"></span>
                    </button>

                    <!-- header icons -->
                    <div id="desktop-singout" class="navbar-nav">
                        <div class="nav-item main-nav text-nowrap" style="padding-right: 0;">
                            <!-- <div> -->
                                <img style="" src="../assets/images/bellIconHeader.png" />
                                <img style="margin-left: 10px;" src="../assets/images/searchIconHeader.png" />
                            <!-- </div> -->
                            <!-- wallet -->
                            <b-dropdown v-if="showWallet" size="lg"  variant="link" toggle-class="text-decoration-none" right no-caret style="display: none;right: 5px; position: relative;">
                                <template #button-content>
                                    <i class="fa-solid fa-wallet header-icons"></i>
                                </template>
                                <b-dropdown-text class="wallet-container">
                                    <Wallet :showNFT="showNFT" ref="Wallet"/>
                                </b-dropdown-text>
                                <div style="position: absolute; bottom: 5px; right: 0; width: 100%; text-align: center; font-size: 12px;">
                                    <hr style="margin: 0; margin-bottom: 3px;"/>
                                    <i class="fa-regular fa-circle-check" style="color: rgb(25, 135, 84);"></i> verified on Ethereum (testnet)
                                </div>
                            </b-dropdown>

                            <!-- notifications -->
                            <!-- <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" right no-caret display="none">
                                <template #button-content>
                                    <font-awesome-icon icon="fa-regular fa-bell" class="header-icons" />
                                </template>
                                <b-dropdown-text>No Notifications</b-dropdown-text>
                            </b-dropdown> -->

                            <!-- notifications -->
                            <b-dropdown style="display: none;" size="lg"  variant="link" toggle-class="text-decoration-none" right no-caret>
                                <template #button-content>
                                    <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="header-icons" />
                                </template>
                                <!-- <b-dropdown-text>No Notifications</b-dropdown-text> -->
                            </b-dropdown>    

                            <!-- user menu -->
                            <b-dropdown style="margin-left: 2px;" size="lg" variant="link" toggle-class="text-decoration-none" right no-caret>
                                <template #button-content class="header-user-icon">
                                    <font-awesome-icon icon="fa-regular fa-user" class="header-icons" style="padding-left:0"/>
                                </template>
                                <b-dropdown-text>Signed in as <b>{{ userName }}</b></b-dropdown-text>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item href="/presentation" target="_blank"><i class="fa-solid fa-image"></i>&nbsp;&nbsp;&nbsp;Presentation (image)</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item href="https://vimeo.com/767113286/1d90357fc4" target="_blank"><i class="fa-solid fa-video"></i>&nbsp;&nbsp;&nbsp;Presentation (video)</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>                                               
                                <b-dropdown-item href="/nftvideotestfullscreen"><i class="fa-solid fa-bell"></i>&nbsp;&nbsp;&nbsp;Notification Test</b-dropdown-item>                            
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item href="/sensorDashboard"><i class="fa-solid fa-microchip"></i>&nbsp;&nbsp;&nbsp;Sensor Dashboard</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item href="/aquacultureDashboard"><i class="fa-solid fa-fish-fins"></i>&nbsp;&nbsp;&nbsp;Aquaculture Dashboard</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>                            
                                <b-dropdown-item href="/logout"><i class="fa-solid fa-right-from-bracket"></i>&nbsp;&nbsp;&nbsp;Sign out</b-dropdown-item>
                            </b-dropdown>

                        </div>
                    </div>

                </div>
            </header>

            <!-- mobile nav -->
            <div id="mySidenav" class="sidenav">
                <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
                <div id="mobile_nav_items" style="display: none; white-space: nowrap;" class="animate__animated animate__fadeIn">
                    <!-- <a href="#" class="mobile-nav-item">

                        <NFTVideoTest ref="NFTVideoTest"/>                    

                    </a> -->

                    <a href="/nftvideotestfullscreen">Notification Test</a>   

                    <div v-for="item in sideNav" v-bind:key="item.id">
                        <a v-if="item.enabled && !item.restricted" class="mobile-nav-item" href="#" v-bind:class="{'mobile-nav-active':item.selected === true}" @click="sideNavClick(item.label)">{{ item.label }}</a>
                    </div>
                    <div>
                        <a class="mobile-nav-item" href="/aquacultureDashboard">Huon</a>
                    </div>
                    <router-link to="/logout">
                        <a href="#" id="mobile-sign-out">Sign Out</a>
                    </router-link> 
                    <div v-if="!restrictedLifeLinkUser" id="vaSwitch-mobile" style="font-size: 16px;">
                        <span v-if="AIChecked" style="margin-right: 10px;">
                            <img style="border-radius: 43px; height: 19px; margin-top: -3px; cursor: pointer;" src="https://mcaloon.org/chat.png" @click="assistantTestModal()" v-b-modal="'asssistant-test-modal'" />
                        </span>        
                        <b-form-checkbox v-model="AIChecked" name="check-button" switch style="display: inline-block; margin-left: 5px; color: #FFF">Virtual Assistant</b-form-checkbox>
                    </div>
                </div>
            </div>

            <!-- AI switch -->
            <div v-if="!restrictedLifeLinkUser && !sideNavToggle" id="vaSwitch-desktop" style="display: none; position: absolute; bottom: 50px; left: 20px; font-size: 16px; z-index: 1000; position: fixed">
                <span v-if="AIChecked" style="margin-right: 10px;">
                    <img style="border-radius: 43px; height: 19px; margin-top: -3px; cursor: pointer;" src="https://mcaloon.org/chat.png" @click="assistantTestModal()" v-b-modal="'asssistant-test-modal'" />
                </span>        
                <b-form-checkbox v-model="AIChecked" name="check-button" switch style="display: inline-block; margin-left: 5px;">Virtual Assistant</b-form-checkbox>
            </div>

            <!-- AI voice test modal -->
            <b-modal id="asssistant-test-modal" title="Virtual Assistant Settings">

                <!-- loading spinner -->
                <div v-if="loadingVoices" id="assistantTestModal-loading" style="margin: 50px;">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <!-- <div>initializing Vitrual Assistant...</div> -->
                </div>

                <!-- modela content -->
                <div v-else id="assistantTestModalContent">
                    
                    <b-form-group label="Language">
                        <b-form-select 
                            v-model="voiceLanguageSelected" 
                            :options="voiceLanguageOptions"
                            @change="getVoices()"
                            size="sm">
                        </b-form-select>
                    </b-form-group>

                    <b-form-group label="Voice">
                        <b-form-select 
                            v-model="voiceSelected" 
                            :options="voiceOptions"
                            @change="getEngine()"
                            size="sm">
                        </b-form-select>
                    </b-form-group>
                    
                    <div style="width: 100%; float: left">
                        <b-button v-if="voiceChangeLoading" variant="primary btn-sm" style="float: right; margin-top: 10px; margin-left: 15px;" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span style="padding-left: 10px;">Change Voice</span>
                        </b-button>
                        <b-button v-else variant="primary btn-sm" @click="changeVoice()" style="float: right; margin-top: 10px; margin-left: 15px;">Change Voice</b-button>

                        <b-button v-if="restoreVoiceTestLoading" variant="primary btn-sm" style="float: right; margin-top: 10px;" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span style="padding-left: 10px;">Restore Default Voice</span>
                        </b-button>
                        <b-button v-else variant="primary btn-sm" @click="restoneVoiceTest()" style="float: right; margin-top: 10px;">Restore Default Voice</b-button>                
                    </div>

                    <div style="width: 100%; float: left; margin-top: 16px;">
                        <hr />
                        <b-form-group label="Input Text">
                            <b-form-textarea v-model="voiceText"></b-form-textarea>
                        </b-form-group>
                    </div>

                    <b-button v-if="voiceTestLoading" variant="primary btn-sm" style="float: right; margin-top: 10px; margin-left: 15px;" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span style="padding-left: 10px;">Test Voice</span>
                    </b-button>
                    <b-button v-else variant="primary btn-sm" @click="voiceTest()" style="float: right; margin-top: 10px; margin-left: 15px;">Test Voice</b-button>

                </div>

                <template #modal-footer>
                    <button v-b-modal.modal-close_visit class="btn btn-secondary btn-sm" @click="$bvModal.hide('asssistant-test-modal')">Close</button>
                </template>
            </b-modal>

            <!-- main content -->
            <div class="container-fluid" style="height: calc(100vh - 90px); overflow: auto; position: relative; top: 56px; padding:0">
                <div class="side-nav-container">

                    <!-- side nav -->
                    <nav id="sidebar-menu" :class="sideNavToggle ? 'sidebar-menu-collapsed' : ''">                    
                        <div class="">

                            <!-- side nav toggle -->
                            <div id="side-nav-toggle-container" :class="sideNavToggle ? 'side-nav-toggle-collapsed' : ''" @click="toggleSideNav()">
                                <i style="color: #333333; font-size: 20px; margin-top: 9px;" class="fa-solid" :class="sideNavToggle ? 'fa-circle-chevron-right' : 'fa-circle-chevron-left'"></i>
                            </div>

                            <!-- nav items -->
                            <ul class="nav flex-column">
                                <div v-for="item in sideNav" v-bind:key="item.id" style="position: relative;">

                                    <!-- top level -->
                                    <li v-if="item.enabled && !item.restricted" class="nav-item sidenav-item" :class="[item.selected === true ? 'bc-active' : '', sideNavToggle ? 'sidenav-item-collapsed' : '']" @click="sideNavClick(item.label)">                                    
                                        <div class="side-nav-icon">

                                            <svg v-if="item.label == 'Dashboard'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1rbdk9p" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z"></path></svg>
                                            <svg v-else-if="item.label == 'Intelligence'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><circle cx="10" cy="8" r="4"></circle><path d="M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 0 1-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></svg>
                                            <svg v-else-if="item.label == 'Dashboard  '" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>
                                            <svg v-else-if="item.label == 'Devices'" style="margin-top: -4px !important;" focusable="false" aria-hidden="true" class="chakra-icon chakra-icon css-1q7v2v0" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>
                                            <svg v-else-if="item.label == 'Dashboard   '" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>
                                            <svg v-else-if="item.label == 'Workflow Settings'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"></path></svg>                                            
                                            <svg v-else-if="item.label == 'Blockchain'" style="margin-top: -4px !important;" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="currentColor" class="chakra-icon chakra-icon css-1n5gron"><path d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"></path></svg>
                                            <font-awesome-icon v-else-if="item.label == 'LifeLink'" icon="fa-solid fa-vector-square"/>
                                            <i v-else :class="[item.icon]"></i>

                                        </div>
                                        <span v-if="!sideNavToggle">

                                            <span v-if="item.label =='Blockchain'" class="nav-item-label">Workflows</span>
                                            <span v-else class="nav-item-label">{{ item.labelText }}</span>

                                            <span v-if="item.subItems.length > 0" style="float: right; margin-right: 20px; position: absolute; right: 0;"><i v-bind:class="[item.subItemsExpanded ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down']"></i></span>
                                        </span>
                                    </li>

                                    <!-- sub level (collapsed only) -->
                                    <div v-if="item.label == 'Blockchain' && sideNavToggle && showBlockchainCollapsedSubitems" id="blockchain-collapsed-sub-items">
                                        <div v-for="subItem in item.subItems" v-bind:key="subItem.id">
                                            <li class="nav-item sub-item-collapsed" :class="subItem.label == 'Animal Health' ? 'sub-item-collapsed-last' : ''" @click="sideNavClick(subItem.label)">
                                                <span>
                                                    {{ subItem.label }}
                                                </span> 
                                            </li>
                                        </div>
                                    </div>

                                    <!-- sub level -->
                                    <div v-if="!sideNavToggle">
                                        <div v-for="subItem in item.subItems" v-bind:key="subItem.id">
                                            <b-collapse id="collapse-blockchain" :visible="item.subItemsExpanded">

                                                <!-- Bovine and Aqua -->
                                                <li class="nav-item" style="margin-left: 56px;" v-bind:class="{'bc-active':subItem.selected === true}" @click="sideNavClick(subItem.label)">
                                                    <div class="side-nav-icon">

                                                        <svg v-if="subItem.label == 'Dashboard '" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>                                                        
                                                        <svg v-else-if="subItem.label == 'User Management'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></svg>
                                                        <svg v-else-if="subItem.label == 'System Settings'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"></path></svg>
                                                        <svg v-else-if="subItem.label == 'Human'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z"></path></svg>
                                                        <svg v-else-if="subItem.label == 'Bovine'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M96 224l0 32 0 160c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88.2c9.9 6.6 20.6 12 32 16.1l0 24.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24.2c11.4-4 22.1-9.4 32-16.1l0 88.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L272 64l-16 0-64 0-48 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"></path></svg>
                                                        <svg v-else-if="subItem.label == 'Aquaculture'" style="margin-top: -4px !important;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" focusable="false" aria-hidden="true" class="chakra-icon css-1p95nbn" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path></svg>                                                        
                                                        <i v-else :class="[subItem.icon]"></i>

                                                    </div>
                                                    <span>
                                                        {{ subItem.label }}
                                                    </span> 
                                                </li>

                                            </b-collapse>
                                        </div>
                                    </div>                                                                   

                                </div>
                            </ul>          
                            
                            <!-- azure logo -->
                            <div v-if="!sideNavToggle" style="position: absolute; bottom: 108px; left: 73px; width: 300px;">               
                                <div style="position: absolute; top: 1px; left: 0px; font-size: 10px; color: #737373; text-transform: uppercase;">Secured and powered by</div>
                                <img style="height: 29px; position: absolute; top: 18px; left: 0px;" src="../assets/images/azure-lock.png" />
                                <div style="height: 26px; width: 1px; background-color: #a4a4a4; position: absolute; top: 20px; left: 33px;"></div>
                                <img style="height: 53px; position: absolute; top: 6px; left: 45px;" src="../assets/images/Mircosoft-Azure-Logo.png" />
                            </div>

                        </div>
                    </nav>

                    <!-- pages -->
                    <main id="main-content-container" :class="sideNavToggle ? 'main-content-container-side-nav-collapsed' : ''">                    
                        <div class="section-container" style="margin-bottom: 100px;">
                            <!-- Check if user is logged-in -->
                            <b-alert
                                :show="dismissCountDown"
                                dismissible
                                variant="info"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged"
                                style="margin-top: 5px;"
                            >
                                <p>User session is expired. Please <a href="/logout">log-in</a> again to continue. Redirecting to log-in page in {{ dismissCountDown }} seconds...</p>
                                <b-progress
                                    variant="info"
                                    :max="dismissSecs"
                                    :value="dismissCountDown"
                                    height="4px"
                                ></b-progress>
                            </b-alert>

                            <!-- Dashboard (HOME) -->
                            <div v-if="selectedSideNav.label == 'Dashboard'" class="page-content">
                                    <h1 class="h2 page-section-title">
                                        <svg style="margin-top: -5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" focusable="false" aria-hidden="true" class="chakra-icon css-1rbdk9p" height="42" width="42" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z"></path></svg>
                                        <span>Home Dashboard</span>
                                    </h1>
                                    <hr class="page-section-hr"/>
                                <div style="float: left; width: 100%">
                                    <h2 style="margin-top: 25px; font-weight: initial;"></h2>
                                    <dashboard ref="dashboard"/>
                                </div>
                            </div>

                            <!-- LifeLInk Dashboard -->
                            <div v-if="selectedSideNav.label == 'Dashboard  '" class="page-content">
                                    <h1 class="h2 page-section-title">
                                        <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" class="chakra-icon css-1rbdk9p" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="42" width="42" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>                                        
                                        <span>LifeLink Dashboard</span>
                                    </h1>
                                    <hr class="page-section-hr"/>
                                <div style="float: left; width: 100%">
                                    <h2 style="margin-top: 25px; font-weight: initial;"></h2>
                                    <LifeLinkDashboard ref="lifeLinkDashboard"/>
                                </div>
                            </div>          
                            
                            <!-- Workflow Dashboard -->
                            <div v-if="selectedSideNav.label == 'Dashboard   '" class="page-content">
                                    <h1 class="h2 page-section-title">
                                        <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" class="chakra-icon css-1rbdk9p" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="42" width="42" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>                                        
                                        <span>Workflow Dashboard</span>
                                    </h1>
                                    <hr class="page-section-hr"/>
                                <div style="float: left; width: 100%">
                                    <h2 style="margin-top: 25px; font-weight: initial;"></h2>
                                    <WorkflowDashboard ref="workflowDashboard"/>
                                </div>
                            </div>                                  

                            <!-- LifeLInk -->
                            <div v-if="selectedSideNav.label == 'LifeLink'" class="page-content">

                                <h1 class="h2 page-section-title">
                                    <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" width="38" height="38" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="chakra-icon chakra-icon css-1q7v2v0"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>                                    
                                    <span>Devices</span>
                                </h1>
                                <hr class="page-section-hr"/>

                                <!-- device view drop down-->
                                <!-- <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><svg focusable="false" aria-hidden="true" width="42" height="42" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="chakra-icon chakra-icon css-1q7v2v0" style="margin-top: -4px !important;"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg> Devices</h1> -->
                                    <!-- <h1 class="h2 page-section-title">
                                        <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" class="chakra-icon css-1rbdk9p" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="42" width="42" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"></path></svg>                                        
                                        <span>Devices</span>
                                    </h1> -->
                                    <!-- <hr class="page-section-hr"/> -->
                                    <!-- <div style="margin-top: 11px; display: none;">
                                        <b-form-select v-model="lifeLinkView" :options="lifeLinkViewOptions" @change="lifeLinkViewChnage()" size="sm"></b-form-select>
                                    </div> -->
                                <!-- </div> -->

                                <!-- loading spinner -->
                                <div id="lifelink-loading">
                                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                                    <!-- <div>Connecting to live data feed...</div> -->
                                </div>     

                                <!-- lifelink dashboard -->
                                <div id="lifelink-container" style="display: none;">
                                    <!-- filter Type -->
                                    <div v-if="lifeLinkView == 'type'">
                                        <h4 class="device-filter-heading">Vitrafy Devices</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="!item.testDevice" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                            <div v-for="deviceItem in virtualDevices" v-bind:key="deviceItem.id">
                                                <div v-if="!deviceItem.testDevice" class="card-container">
                                                    <device-card-virtual :device="deviceItem" />
                                                </div>
                                            </div>                                            
                                        </div>
                                        <h4 class="device-filter-heading">IoT Connection</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.testDevice" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                            <div v-for="deviceItem in virtualDevices" v-bind:key="deviceItem.id">
                                                <div v-if="deviceItem.testDevice" class="card-container">
                                                    <device-card-virtual :device="deviceItem" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Filter Location -->
                                    <div v-if="lifeLinkView == 'location'">
                                        <h4 class="device-filter-heading">Huon Aquaculture (Tasmania)</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Huon Aquaculture (Tasmania)'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">Vitrafy Lab</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Vitrafy Lab'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                            <div v-for="deviceItem in virtualDevices" v-bind:key="deviceItem.id">
                                                <div class="card-container">
                                                    <device-card-virtual :device="deviceItem" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">Vitrafy Design Lab</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Vitrafy Design Lab'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">Vitrafy Engineering</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Vitrafy Engineering'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">BioBridge Global (USA)</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'BioBridge Global (USA)'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">IMV Technologies (France)</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'IMV Technologies (France)'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <h4 class="device-filter-heading">Select Sires International (USA)</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Select Sires International (USA)'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <h4 class="device-filter-heading">Australian Red Cross Lifeblood (Sydney)</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Australian Red Cross Lifeblood (Sydney)'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div> -->
                                        
                                        <!-- <h4 class="device-filter-heading">Virtual</h4>
                                        <div class="device-filter-container">
                                            <div v-for="deviceItem in virtualDevices" v-bind:key="deviceItem.id">
                                                <div class="card-container">
                                                    <device-card-virtual :device="deviceItem" />
                                                </div>
                                            </div>
                                        </div> -->

                                        <h4 class="device-filter-heading">Global</h4>
                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.location == 'Global'" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Deal with new devices detected -->
                                        <!-- <div v-if="unregisteredDevices.length > 0">
                                            <h4 class="device-filter-heading">New</h4>
                                            <div class="device-filter-container">
                                                <div v-for="device in unregisteredDevices" v-bind:key="device.ID">
                                                    <div class="card-container">                                                
                                                        <register-device :device="device" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        
                                    </div>

                                    <!-- filter Registered -->
                                    <div v-if="lifeLinkView == 'registered'" style="position: relative;">
                                        <!-- <h4 class="device-filter-heading">Registered Devices</h4> -->
                                        <div style="margin-bottom: 25px;"></div>
                                        <!-- Add Device button -->
                                        <!-- <div id="blockchain-button-container" style="position: absolute; top: 0; right: 0;">
                                            <button id="create-new-contract-button" type="button" class="btn btn-primary btn-sm action-button" v-b-modal="'new-contract-modal'">
                                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus">
                                                    <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path>
                                                </svg>
                                                <span style="padding-left: 10px;">Add Device</span>
                                            </button>
                                        </div>  -->

                                        <div class="device-filter-container">
                                            <div v-for="item in items" v-bind:key="item.id">
                                                <div v-if="item.registered" class="card-container">
                                                    <device-card :item="item" />
                                                </div>
                                            </div>
                                            <div v-for="deviceItem in virtualDevices" v-bind:key="deviceItem.id">
                                                <div v-if="deviceItem.registered" class="card-container">
                                                    <device-card-virtual :device="deviceItem" />
                                                </div>
                                            </div>                                            
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- Tracking -->
                            <div v-if="selectedSideNav.label == 'Tracking'" class="page-content">
                                <!-- Lab Devices -->
                                <!-- <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2" style="float:left; width: 100%;"><font-awesome-icon icon="fa-solid fa-map" /> Tracking</h1>
                                </div> -->
                                <h1 class="h2 page-section-title">
                                    <!-- <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" width="38" height="38" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="chakra-icon chakra-icon css-1q7v2v0"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>                                     -->
                                    <font-awesome-icon icon="fa-solid fa-map" /> 
                                    <span>Tracking</span>
                                </h1>
                                <hr class="page-section-hr"/>
                                <div style="margin-bottom: 25px;"></div>

                                <!-- loading spinner -->
                                <div id="tracking-loading">
                                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                                    <!-- <div>Connecting to live data feed...</div> -->
                                </div>                            

                                <!-- tracking dashboard -->
                                <div id="tracking-container">

                                    <!-- Live icon (flashing) -->
                                    <div style="position: relative; padding-left:20px; float: left;">
                                        <span style="color:red; font-weight: bold;">LIVE DATA</span>
                                        <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                                            <circle cx="20" cy="20" r="5" fill="red" />
                                        </svg> 
                                    </div> 

                                    <!-- Earth view button -->
                                    <div style="float: right;">
                                        <a href="/earth" id="earthLoadingButton" class="btn btn-sm btn-primary" type="button">
                                            <i class="fa-solid fa-earth-americas"></i>
                                            <span style="padding-left: 10px">Earth View</span>
                                        </a>
                                    </div>
                                    
                                    <br /><br />

                                    <add-google-map ref="googleMaps"/>

                                    <!-- <div style="float: right;">
                                        <button @click="getTrackingData()" type="button" class="btn btn-sm btn-primary">Refresh Data</button> 
                                    </div> -->

                                    <br /><br />

                                    <!-- tabs TEMP HIDDEN-->
                                    <b-tabs content-class="mt-3" style="padding-top: 30px; display: none;">
                                        <b-tab :title="tabTrackingDataAll" @click="trackingTabChanged(0)" :active="tab == 0 ? true : false">
                                            
                                            <div style="display: block; overflow: auto;">
                                                <table class="table" id="live-data-table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Timestamp</th>
                                                            <th>Device ID</th>
                                                            <th>Cell ID</th>                                        
                                                            <th>LAC</th>
                                                            <th>MCC</th>
                                                            <th>MNC</th>
                                                            <th>RSSI</th>
                                                            <th></th>
                                                        </tr>                               
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="row in trackingDataAll" v-bind:key="row.ITEM_ID">
                                                            <td> {{ row.rowNumber }}</td>
                                                            <td> {{ row.formattedTimestamp }}</td>
                                                            <td> {{ row.ID }}</td>                                        
                                                            <td> {{ row.CELLID }}</td>
                                                            <td> {{ row.LAC }}</td>
                                                            <td> {{ row.MCC }}</td>
                                                            <td> {{ row.MNC }}</td>
                                                            <td> {{ row.RSSI }}</td>
                                                            <td style="text-align: right;"> 
                                                                <button v-if="row.CELLID.length > 0" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary">show on map</button>
                                                                <button v-if="row.CELLID.length < 1" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary disabled">show on map</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </b-tab>
                                        <b-tab :title="tabTrackingDataRpi4G" @click="trackingTabChanged(1)" :active="tab == 1 ? true : false">

                                            <div style="display: block; overflow: auto;">
                                                <table class="table" id="live-data-table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Timestamp</th>
                                                            <th>Device ID</th>
                                                            <th>Cell ID</th>                                        
                                                            <th>LAC</th>
                                                            <th>MCC</th>
                                                            <th>MNC</th>
                                                            <th>RSSI</th>
                                                            <th></th>
                                                        </tr>                               
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="row in trackingDataRpi4G" v-bind:key="row.ITEM_ID">
                                                            <td> {{ row.rowNumber }}</td>
                                                            <td> {{ row.formattedTimestamp }}</td>
                                                            <td> {{ row.ID }}</td>                                        
                                                            <td> {{ row.CELLID }}</td>
                                                            <td> {{ row.LAC }}</td>
                                                            <td> {{ row.MCC }}</td>
                                                            <td> {{ row.MNC }}</td>
                                                            <td> {{ row.RSSI }}</td>
                                                            <td style="text-align: right;">
                                                                <button v-if="row.CELLID.length > 0" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary">show on map</button>
                                                                <button v-if="row.CELLID.length < 1" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary disabled">show on map</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </b-tab>
                                        <b-tab :title="tabTrackingDataRpi4G02" @click="trackingTabChanged(2)" :active="tab == 2 ? true : false">

                                            <div style="display: block; overflow: auto;">
                                                <table class="table" id="live-data-table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Timestamp</th>
                                                            <th>Device ID</th>
                                                            <th>Cell ID</th>                                        
                                                            <th>LAC</th>
                                                            <th>MCC</th>
                                                            <th>MNC</th>
                                                            <th>RSSI</th>
                                                            <th></th>
                                                        </tr>                               
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="row in trackingDataRpi4G02" v-bind:key="row.ITEM_ID">
                                                            <td> {{ row.rowNumber }}</td>
                                                            <td> {{ row.formattedTimestamp }}</td>
                                                            <td> {{ row.ID }}</td>                                        
                                                            <td> {{ row.CELLID }}</td>
                                                            <td> {{ row.LAC }}</td>
                                                            <td> {{ row.MCC }}</td>
                                                            <td> {{ row.MNC }}</td>
                                                            <td> {{ row.RSSI }}</td>
                                                            <td style="text-align: right;">
                                                                <button v-if="row.CELLID.length > 0" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary">show on map</button>
                                                                <button v-if="row.CELLID.length < 1" @click="getLocationTest(row)" type="button" class="btn btn-sm btn-secondary disabled">show on map</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </b-tab>                                                                        
                                    </b-tabs>

                                </div>
                            </div>

                            <!-- Blockchain v1 (OLD version - kept for backup)-->
                            <div v-if="selectedSideNav.label == 'Blockchain v1'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><font-awesome-icon icon="fa-solid fa-cube" /> Blockchain (LifeChain Private Network)</h1>
                                </div>
                                <div style="float: left; width: 100%;">
                                    
                                    <!-- loading spinner -->
                                    <div id = "blockchain-data-loading">
                                        <div class="lds-facebook"><div></div><div></div><div></div></div>
                                        <!-- <div>Blockchain (LifeChain Private Network) processing...</div> -->
                                    </div>

                                    <!-- loading error -->
                                    <div id="blockchain-data-loading-error" style="color: red; display: none; text-align: center; margin-top: 225px;">
                                        <font-awesome-icon icon="fa-solid fa-exclamation-circle" style="font-size: 40px; padding-bottom: 20px;"/>
                                        <div><b>Error</b> - Unable to connect to Blockchain (test network)</div> <br />
                                        <!-- {{ errorDetails }} -->
                                    </div>

                                    <!-- blockchain table -->
                                    <div id="blockchain-table" style="display: none; overflow-y: auto; overflow-x: auto;">
                                        <div style="float: left; width: 100%; margin-bottom: 10px;">
                                            <div style="float: left;">
                                                <h4>BioContracts</h4>
                                            </div>
                                            <div style="float: right;">
                                                <button id="create-new-contract-button" type="button" @click="openNewContractModal" class="btn btn-primary btn-sm action-button" v-b-modal="'new-contract-modal'">
                                                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus">
                                                        <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path>
                                                    </svg>
                                                    <span style="padding-left: 10px;">Create New BioContract</span>
                                                </button>
                                            </div> 
                                        </div>

                                        <!-- tabs -->
                                        <div style="width: 100%; float: left; padding-top: 30px;">
                                            <b-tabs content-class="mt-3">
                                                <b-tab :title="blockchainInProgressCount" active>

                                                    <!-- In progress -->
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                            <th scope="col" style="min-width:130px;">Name</th>                                                                                                                     
                                                            <th scope="col">Created</th>
                                                            <th scope="col">Current State</th>
                                                            <th scope="col">Progress</th>
                                                            <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="block in blockchainInProgress" v-bind:key="block.ID">
                                                                    <td style="min-width:130px; vertical-align: top; white-space: nowrap;">  
                                                                        <a href="#" v-b-modal="'contract-detals-modal'" @click="sendInfo(block, false)">
                                                                            {{ block.name }} 
                                                                        </a>
                                                                    </td>
                                                                <td style="vertical-align: top;"> {{ block.TimeStamp }} </td>
                                                                <td style="vertical-align: top;"> {{ block.StateText }} </td>
                                                                <td class = "chart" Style="width:30%; vertical-align: middle;">
                                                                    <div class="progress">
                                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: block.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                                            <div style="text-align:left; padding-left:10px;">
                                                                                {{ block.stateProgress }} %
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td> 
                                                                <td style="vertical-align: middle;">
                                                                    <!-- new -->
                                                                    <button type="button" @click="blockchainStageComplete(block)" class="btn btn-secondary btn-sm action-button contract-action" style="margin: 0;">Complete Stage</button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </b-tab>
                                                <b-tab :title="blockchainCompletedCount">

                                                    <!-- Completed -->
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                            <!-- <th scope="col">Contract ID</th> -->
                                                            <th scope="col" style="min-width:130px;">Name</th>
                                                            <th scope="col">Created</th>
                                                            <!-- <th scope="col">Current State</th> -->
                                                            <th scope="col">Progress</th>
                                                            <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="block in blockchainCompleted" v-bind:key="block.ID">
                                                                    <td style="min-width:130px;"> 
                                                                        <a href="#" v-b-modal="'contract-detals-modal'" @click="sendInfo(block, false)">
                                                                            {{ block.name }} 
                                                                        </a>
                                                                    </td>
                                                                <!-- <td> {{ block.name }}  </td> -->
                                                                <td> {{ block.TimeStamp }} </td>
                                                                <!-- <td> {{ block.StateText }} </td> -->
                                                                <td class = "chart" Style="width:30%; padding-top: 11px;">
                                                                    <div class="progress">
                                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: '100%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                                            <div style="text-align:left; padding-left:10px;">
                                                                                100 %
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                

                                                </b-tab>
                                                <b-tab :title="blockchainTemplatesCount">

                                                    <!-- Templates -->
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                            <!-- <th scope="col">Contract ID</th> -->
                                                            <th scope="col" style="min-width:130px;">Name</th>                                                                                                                     
                                                            <th scope="col">Created</th>
                                                            <th scope="col">Author</th>
                                                            <!-- <th scope="col">Current State</th>                                                         -->
                                                            <!-- <th scope="col">Progress</th> -->
                                                            <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="block in blockchainTemplates" v-bind:key="block.ID">
                                                                    <td style="min-width:130px;"> 
                                                                        <a href="#" v-b-modal="'contract-template-modal'" @click="sendInfo(block, true)">
                                                                            {{ block.name }} 
                                                                        </a>
                                                                    </td>
                                                                <!-- <td> {{ block.name }}  </td> -->
                                                                <td> {{ block.TimeStamp }} </td>                
                                                                <td> {{ block.User }} </td>                                             
                                                                <!-- <td> {{ block.StateText }} </td>                                                                                                                                                                                                                      -->
                                                                <!-- <td class = "chart" Style="width:30%; padding-top: 11px;">
                                                                    <div class="progress">
                                                                        <div class="progress-bar progress-bar-contract" role="progressbar" v-bind:style="{ width: block.stateProgress + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                                                                            <div style="text-align:left; padding-left:10px;">
                                                                                {{ block.stateProgress }} %
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td> -->
                                                                <td>
                                                                    <!-- Step 1 -->
                                                                    <button v-if="block.State == 0" type="button" @click="step1Click(block)" class="btn btn btn-secondary btn-sm action-button">Complete Doctor Patient Identification</button>
                                                                    <!-- Step 2 -->
                                                                    <button v-if="block.State == 1" type="button" @click="step2Click(block)" class="btn btn btn-secondary btn-sm action-button">Complete Patient Collection</button>
                                                                    <!-- Step 3 -->
                                                                    <button v-if="block.State == 2" type="button" @click="step3Click(block)" class="btn btn btn-secondary btn-sm action-button">Complete Isolation Leukapheresis</button>
                                                                    <!-- Step 4 -->
                                                                    <button v-if="block.State == 3" type="button" @click="step4Click(block)" class="btn btn btn-secondary btn-sm action-button">Complete Controlled Cryopreservation</button>
                                                                    <!-- Step 5 -->
                                                                    <button v-if="block.State == 4" type="button" @click="step5Click(block)" class="btn btn btn-secondary btn-sm action-button">Complete Smart Contract</button>                                                                
                                                                    <!-- Completed -->
                                                                    <span v-if="block.State == 5" style="text-align: center"></span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                                

                                                </b-tab>                                            
                                            </b-tabs>
                                        </div>  

                                        <!-- New contract modal -->
                                        <b-modal id="new-contract-modal" size="md" title="Create New BioContract" button-size="sm" @ok="createNewContract">
                                            <div>
                                                <b-form-group id="input-group-2" label="Contract Name:" label-for="input-2">
                                                    <b-form-input
                                                    id="input-2"
                                                    v-model="contractName"
                                                    placeholder="Enter name for contract"
                                                    required
                                                    ></b-form-input>
                                                </b-form-group>
                                                <b-form-group id="input-group-3" label="Contract Application:" label-for="input-3">
                                                    <b-form-select
                                                    id="input-3"
                                                    v-model="contractApplication"
                                                    :options="contractApplicationOptions"
                                                    required
                                                    ></b-form-select>
                                                </b-form-group>
                                                <b-form-group id="input-group-3" label="Contract Template:" label-for="input-3">
                                                    <b-form-select
                                                    id="input-3"
                                                    v-model="contractTemplate"
                                                    :options="contractTemplateOptions"
                                                    required
                                                    ></b-form-select>
                                                </b-form-group>
                                            </div>
                                        </b-modal>
                                        
                                        <!-- contract details modal -->
                                        <b-modal id="contract-detals-modal" size="lg" title="BioContract Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                                            <div id="blockchain-data-loading-modal" style="display: block;">
                                                <div class="lds-facebook"><div></div><div></div><div></div></div>
                                                <!-- <div>Blockchain (LifeChain Private Network) processing...</div>                                                         -->
                                            </div>
                                            <div id="blockchain-modal" style="display: none;">

                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Contract Name</b></td>
                                                        <td>{{selectedBlock.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Contract ID</b></td>
                                                        <td>{{selectedBlock.displayid }}</td>
                                                    </tr>      
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Created by</b></td>
                                                        <td>{{selectedBlock.User }}</td>
                                                    </tr>   
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Contract Owner</b></td>
                                                        <td>{{selectedBlock.Owner }}</td>
                                                    </tr>     
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Current State</b></td>
                                                        <td>{{selectedBlock.StateText }}</td>
                                                    </tr>
                                                </table>

                                                <div id="main-chain" class="chain" style="float: left; margin-left: 20px; margin-right: 20px;">

                                                    <!-- 1 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- hide top of line -->
                                                        <div style="position: absolute; top: 1px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage1 || selectedBlock.stage0" class="chain-label chain-label-complete">

                                                            <!-- completed -->
                                                            <div v-if="selectedBlock.stage1">
                                                                <img @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover contractImage" src="../assets/images/contractIcons/1.png" />
                                                                <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover chain-label-complete">1. Doctor Patient Identification Completed</div>
                                                                <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover completedText">{{ selectedBlock.stage1 }}</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon" v-bind:class="[infoBoxClosed_1 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>

                                                                <div v-if="!infoBoxClosed_1">
                                                                    <div id="collapse-1" style="float: left; width: 100%">

                                                                        <!-- 1.1 -->
                                                                        <div style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                                                        <div style="float: left; width: 100%;">
                                                                            <div style="width: 33.3%; float: left;">
                                                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('1.1 Doctor registered','1-1','Milestone',selectedBlock.stage1)">
                                                                                    1.1 Doctor registered
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <!-- 1.2 -->
                                                                        <div style="float: left; width: 100%;">
                                                                            <div style="width: 33.3%; float: left;">
                                                                                <div class="info_boc_l1 info_box" @click="selectedMilestone('1.2 Donor/Patient details creation','1-2','Milestone',selectedBlock.stage1)">
                                                                                    1.2 Donor/Patient details creation
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- in progress -->
                                                            <div v-else>
                                                                <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                                <img @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover contractImage contractImageInProgress" src="../assets/images/contractIcons/1.png" />
                                                                <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover chain-label-in-progress">1. Doctor Patient Identification Completed</div>
                                                                <div @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover inProgressText">In Progress</div>

                                                                <!-- info box -->
                                                                <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon" v-bind:class="[infoBoxClosed_1 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>

                                                                <div v-if="!infoBoxClosed_1">
                                                                    <div id="collapse-1" style="float: left; width: 100%">

                                                                        <!-- process line -->
                                                                        <div v-if="process_1_1" style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #0a58ca; border-left: 3px solid #fff; border-right: 1px dashed grey; border-bottom: 1px solid grey;"></div>
                                                                        <div v-if="process_1_1" style="height: 44px; position: absolute; left: -11px; top: 214px; width: 160px; background-color: white; border: 3px solid #fff;  border-top: 1px dashed grey; border-left: 1px dashed grey;"></div>
                                                                        <div v-if="process_1_1" style="height: 62px; position: absolute; left: -11px; top: 46px; width: 160px; background-color: white; border: 3px solid #fff;  border-left: 3px solid #0a58ca; border-bottom: 3px solid #0a58ca;"></div>
                                                                        
                                                                        <!-- 1.1 -->
                                                                        <div style="float: left; width: 100%;">
                                                                            <div style="width: 33.3%; float: left;">
                                                                                
                                                                                <div class="info_boc_l1 info_box info_boc_in_progress info_boc_in_progress" v-b-modal="'milestone-modal'" @click="selectedMilestone('1.1 Doctor registered','1-1','Milestone',selectedBlock.stage1, true)">
                                                                                    1.1 Doctor registered
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <!-- 1.2 -->
                                                                        <div style="float: left; width: 100%;">
                                                                            <div style="width: 33.3%; float: left;">
                                                                                <div class="info_boc_l1 info_box inactiveProcess" @click="selectedMilestone('1.2 Donor/Patient details creation','1-2','Milestone',selectedBlock.stage1)">
                                                                                    1.2 Donor/Patient details creation
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/1.png" />
                                                            1. Doctor Patient Identification
                                                        </div>
                                                    </div>

                                                    <!-- 2 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage2" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover contractImage" src="../assets/images/contractIcons/2.png" />
                                                            <div @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover chain-label-complete">2. Patient Collection Completed</div>
                                                            <div @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover completedText">{{ selectedBlock.stage2 }}</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_2 = !infoBoxClosed_2" class="hover info_box_icon" v-bind:class="[infoBoxClosed_2 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_2">
                                                                <div id="collapse-2" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('2.1 Identification of biological materia selected','2-1','Milestone',selectedBlock.stage2)">
                                                                                2.1 Identification of biological materia selected
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('2.2 Sample volume identified','2-2','Milestone',selectedBlock.stage2)">
                                                                                2.2 Sample volume identified
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('2.3 The MIoT packaging device informed','2-3','Milestone',selectedBlock.stage2)">
                                                                                2.3 The MIoT packaging device informed
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage1" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/2.png" />
                                                            <div class="chain-label-in-progress">2. Patient Collection</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>                                                    
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                                                                                   
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/2.png" />
                                                            2. Patient Collection
                                                        </div>
                                                    </div>

                                                    <!-- 3 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage3" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover contractImage" src="../assets/images/contractIcons/3.png" />
                                                            <div @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover chain-label-complete">3. Isolation Leukapheresis Completed</div>
                                                            <div @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover completedText">{{ selectedBlock.stage3 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_3 = !infoBoxClosed_3" class="hover info_box_icon" v-bind:class="[infoBoxClosed_3 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                        <div v-if="!infoBoxClosed_3">
                                                                <div id="collapse-3" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px; position: absolute; left: 214px; top: 215px; width: 85px; background-color: white; border: 3px solid #fff; border-top: 3px solid #00ad5b;"></div>                                                                
                                                                    <div style="height: 753px; position: absolute; left: -11px; top: 236px; width: 376px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff; border-top: 3px solid #fff;"></div>
                                                                    <div style="height: 113px; position: absolute; left: 438px; top: 436px; width: 85px; background-color: white; border: 3px solid #fff; border-top: 3px solid #00ad5b;"></div>
                                                                    <div style="height: 113px; position: absolute; left: 474px; top: 436px; width: 85px; background-color: white; border: 3px solid #00ad5b; border-right: 3px solid #fff;"></div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('3.1 Collection','3-1','Milestone',selectedBlock.stage3)">
                                                                                3.1 Collection
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('3.2 Pre-cryopreservation','3-2','Milestone',selectedBlock.stage3)">
                                                                                3.2 Pre-cryopreservation
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.1 Pre-cryopreservation processing','3-2-1','Subprocess',selectedBlock.stage3)">
                                                                                3.2.1 Pre-cryopreservation processing
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.2 Selection of MIoT packaging','3-2-2','Subprocess',selectedBlock.stage3)">
                                                                                3.2.2 Selection of MIoT packaging
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.3 Monitoring','3-2-3','Subprocess',selectedBlock.stage3)">
                                                                                3.2.3 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l3 info_box" @click="selectedMilestone('3.2.3.1 Temprature Monitoring','3-2-3-1','Subprocess',selectedBlock.stage3)">
                                                                                3.2.3.1 Temprature Monitoring 
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l3 info_box" @click="selectedMilestone('3.2.3.2 Tracking','3-2-3-2','Subprocess',selectedBlock.stage3)">
                                                                                3.2.3.2 Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.4 Holding until cryopreservation','3-2-4','Subprocess',selectedBlock.stage3)">
                                                                                3.2.4 Holding until cryopreservation
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.5 MIoT cryopreservation device informed','3-2-5','Subprocess',selectedBlock.stage3)">
                                                                                3.2.5 MIoT cryopreservation device informed
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.6 Select racking system and protocol','3-2-6','Subprocess',selectedBlock.stage3)">
                                                                                3.2.6 Select racking system and protocol
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('3.2.7 MIoT smart packaging device will inform other devices','3-2-7','Subprocess',selectedBlock.stage3)">
                                                                                3.2.7 MIoT smart packaging device will inform other devices
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage2" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/3.png" />
                                                            <div class="chain-label-in-progress">3. Isolation Leukapheresis</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>                                                         
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/3.png" />
                                                            3. Isolation Leukapheresis
                                                        </div>
                                                    </div>

                                                    <!-- 4 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage4" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover contractImage" src="../assets/images/contractIcons/4.png" />
                                                            <div @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover chain-label-complete">4. Vitrafy Controlled Cryopreservation Completed</div>
                                                            <div @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover completedText">{{ selectedBlock.stage4 }} - {{  selectedBlock.TempData }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_4 = !infoBoxClosed_4" class="hover info_box_icon" v-bind:class="[infoBoxClosed_4 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_4">
                                                                <div id="collapse-4" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('4.1 Monitoring','4-1','Milestone',selectedBlock.stage4)">
                                                                                4.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('4.1.1 Cryopreservation Temperature Monitoring','4-1-1','Subprocess',selectedBlock.stage4)">
                                                                                4.1.1 Cryopreservation Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('4.1.2 Protocol and Cost Tracking','4-1-2','Subprocess',selectedBlock.stage4)">
                                                                                4.1.2 Protocol and Cost Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" v-b-modal="'milestone-modal'" @click="selectedMilestone('4.2 Cryopreservation','4-2','Milestone',selectedBlock.stage4)">
                                                                                4.2 Cryopreservation 
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage3" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/4.png" />
                                                            <div class="chain-label-in-progress">4. Vitrafy Controlled Cryopreservation</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>                                                       
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/4.png" />
                                                            4. Vitrafy Controlled Cryopreservation
                                                        </div>
                                                    </div>

                                                    <!-- 5 -->
                                                    <div class="chain-row chain-row-item">
                                                        <div v-if="selectedBlock.stage5" class="chain-label chain-label-complete">
                                                            <!-- summary -->
                                                            <img @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover contractImage" src="../assets/images/contractIcons/5.png" />
                                                            <div @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover chain-label-complete">5. Specialised Logistics Completed</div>
                                                            <div @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover completedText">{{ selectedBlock.stage5 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_5 = !infoBoxClosed_5" class="hover info_box_icon" v-bind:class="[infoBoxClosed_5 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_5">
                                                                <div id="collapse-5" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('5.1 Monitoring','5-1','Milestone',selectedBlock.stage5)">
                                                                                5.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('5.1.1 Temperature Monitoring','5-1-1','Subprocess',selectedBlock.stage5)">
                                                                                5.1.1 Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('5.1.2 Location Tracking','5-1-2','Subprocess',selectedBlock.stage5)">
                                                                                5.1.2 Location Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('5.2 Identification of Target destination','5-2','Milestone',selectedBlock.stage5)">
                                                                                5.2 Identification of Target destination 
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage4" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/5.png" />
                                                            <div class="chain-label-in-progress">5. Specialised Logistics</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>                                                         
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/5.png" />
                                                            5. Specialised Logistics
                                                        </div>
                                                    </div> 

                                                    <!-- 6 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage6" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover contractImage" src="../assets/images/contractIcons/6.png" />
                                                            <div @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover chain-label-complete">6. Vitrafy Controlled Biothaw Completed</div>
                                                            <div @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover completedText">{{ selectedBlock.stage6 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_6 = !infoBoxClosed_6" class="hover info_box_icon" v-bind:class="[infoBoxClosed_6 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_6">
                                                                <div id="collapse-6" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 334px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('6.1 Monitoring','6-1','Milestone',selectedBlock.stage6)">
                                                                                6.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('6.1.1 Temperature Monitoring','6-1-1','Subprocess',selectedBlock.stage6)">
                                                                                6.1.1 Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('6.1.2 Protocol and Cost Tracking','6-1-2','Subprocess',selectedBlock.stage6)">
                                                                                6.1.2 Protocol and Cost Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('6.2 Protocol Selection','6-2','Milestone',selectedBlock.stage6)">
                                                                                6.2 Protocol Selection
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('6.3 Thawing','6-2','Milestone',selectedBlock.stage6)">
                                                                                6.3 Thawing
                                                                            </div>
                                                                        </div>
                                                                    </div>                                                                
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage5" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/6.png" />
                                                            <div class="chain-label-in-progress">6. Vitrafy Controlled Biothaw</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>                                                         
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/6.png" />
                                                            6. Vitrafy Controlled Biothaw
                                                        </div>
                                                    </div>  

                                                    <!-- 7 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage7" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover contractImage" src="../assets/images/contractIcons/7.png" />
                                                            <div @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover chain-label-complete">7. Differentiation Transformation Completed</div>
                                                            <div @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover completedText">{{ selectedBlock.stage7 }}</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_7 = !infoBoxClosed_7" class="hover info_box_icon" v-bind:class="[infoBoxClosed_7 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_7">
                                                                <div id="collapse-7" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('7.1 DNA Plasmid Process','7-1','Milestone',selectedBlock.stage7)">
                                                                                7.1 DNA Plasmid Process
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('7.2 T Cell Process','7-2','Milestone',selectedBlock.stage7)">
                                                                                7.2 T Cell Process
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('7.3 MIoT packaging checks','7-3','Milestone',selectedBlock.stage7)">
                                                                                7.3 MIoT packaging checks
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage6" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/7.png" />
                                                            <div class="chain-label-in-progress">7. Differentiation Transformation</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/7.png" />
                                                            7. Differentiation Transformation
                                                        </div>
                                                    </div>

                                                    <!-- 8 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage8" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover contractImage" src="../assets/images/contractIcons/8.png" />
                                                            <div @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover chain-label-complete">8. Expansion Completed</div>
                                                            <div @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover completedText">{{ selectedBlock.stage8 }}</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_8 = !infoBoxClosed_8" class="hover info_box_icon" v-bind:class="[infoBoxClosed_8 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_8">
                                                                <div id="collapse-8" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 444px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff"></div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('8.1 Biological material expanded','8-1','Milestone',selectedBlock.stage8)">
                                                                                8.1 Biological material expanded
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('8.2 determine if subsequent cycles are required','8-2','Milestone',selectedBlock.stage8)">
                                                                                8.2 determine if subsequent cycles are required
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('8.3 Holding until cryopreservation','8-3','Milestone',selectedBlock.stage8)">
                                                                                8.3 Holding until cryopreservation
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('8.4 MIoT Cryopreservation device informed','8-4','Milestone',selectedBlock.stage8)">
                                                                                8.4 MIoT Cryopreservation device informed
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('8.5 Select racking system and protocol ','8-5','Milestone',selectedBlock.stage8)">
                                                                                8.5 Select racking system and protocol 
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage7" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/8.png" />
                                                            <div class="chain-label-in-progress">8. Expansion</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/8.png" />
                                                            8. Expansion
                                                        </div>
                                                    </div>

                                                    <!-- 9 -->
                                                    <div class="chain-row chain-row-item">
                                                        <div v-if="selectedBlock.stage9" class="chain-label chain-label-complete">
                                                            <!-- summary -->
                                                            <img @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover contractImage" src="../assets/images/contractIcons/9.png" />
                                                            <div @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover chain-label-complete">9. Vitrafy Controlled Cryopreservation Completed</div>
                                                            <div @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover completedText">{{ selectedBlock.stage9 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_9 = !infoBoxClosed_9" class="hover info_box_icon" v-bind:class="[infoBoxClosed_9 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_9">
                                                                <div id="collapse-9" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('9.1 Monitoring','9-1','Milestone',selectedBlock.stage9)">
                                                                                9.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('9.1.1 Cryopreservation Temperature Monitoring','9-1-1','Subprocess',selectedBlock.stage9)">
                                                                                9.1.1 Cryopreservation Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('9.1.2 Protocol and Cost Tracking','9-1-2','Subprocess',selectedBlock.stage9)">
                                                                                9.1.2 Protocol and Cost Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('9.2 Cryopreservation','9-2','Milestone',selectedBlock.stage9)">
                                                                                9.2 Cryopreservation
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage8" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/9.png" />
                                                            <div class="chain-label-in-progress">9. Vitrafy Controlled Cryopreservation</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/9.png" />
                                                            9. Vitrafy Controlled Cryopreservation
                                                        </div>
                                                    </div>

                                                    <!-- 10 -->
                                                    <div class="chain-row chain-row-item">
                                                        <div v-if="selectedBlock.stage10" class="chain-label chain-label-complete">
                                                            <!-- summary -->
                                                            <img @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover contractImage" src="../assets/images/contractIcons/10.png" />
                                                            <div @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover chain-label-complete">10. Specialised Logistics Completed</div>
                                                            <div @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover completedText">{{ selectedBlock.stage10 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_10 = !infoBoxClosed_10" class="hover info_box_icon" v-bind:class="[infoBoxClosed_10 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_10">
                                                                <div id="collapse-10" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 225px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('10.1 Monitoring','10-1','Milestone',selectedBlock.stage10)">
                                                                                10.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('10.1.1 Temperature Monitoring','10-1-1','Subprocess',selectedBlock.stage10)">
                                                                                10.1.1 Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('10.1.2 Location Tracking','10-1-2','Subprocess',selectedBlock.stage10)">
                                                                                10.1.2 Location Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('10.2 Identification of Target destination','10-2','Milestone',selectedBlock.stage10)">
                                                                                10.2 Identification of Target destination
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage9" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/10.png" />
                                                            <div class="chain-label-in-progress">10. Specialised Logistics</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/10.png" />
                                                            10. Specialised Logistics
                                                        </div>
                                                    </div>

                                                    <!-- 11 -->
                                                    <div class="chain-row chain-row-item">
                                                        <div v-if="selectedBlock.stage11" class="chain-label chain-label-complete">
                                                            <!-- summary -->
                                                            <img @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover contractImage" src="../assets/images/contractIcons/11.png" />
                                                            <div @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover chain-label-complete">11. Vitrafy Controlled Biothaw Completed</div>
                                                            <div @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover completedText">{{ selectedBlock.stage11 }}</div>

                                                        <!-- info box -->
                                                        <i @click="infoBoxClosed_11 = !infoBoxClosed_11" class="hover info_box_icon" v-bind:class="[infoBoxClosed_11 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_11">
                                                                <div id="collapse-11" style="float: left; width: 100%" class="mt-2">
                                                                    <div style="height: 334px; position: absolute; left: -11px; top: 103px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 212px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;"></div>
                                                                    <div style="height: 113px;position: absolute;left: 257px;top: 103px;width: 85px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(255, 255, 255) rgb(0, 173, 91) rgb(0, 173, 91);border-image: initial;"></div>                                                                
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('11.1 Monitoring','11-1','Milestone',selectedBlock.stage11)">
                                                                                11.1 Monitoring
                                                                            </div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('11.1.1 Temperature Monitoring','11-1-1','Subprocess',selectedBlock.stage11)">
                                                                                11.1.1 Temperature Monitoring
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_box" style="background-color: #fff; border: none; z-index: -1;"></div>
                                                                        </div>
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l2 info_box" @click="selectedMilestone('11.1.2 Protocol and Cost Tracking','11-1-2','Subprocess',selectedBlock.stage11)">
                                                                                11.1.2 Protocol and Cost Tracking
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('11.2 Protocol Selection','11-2','Milestone',selectedBlock.stage11)">
                                                                                11.2 Protocol Selection  
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('11.3 Thawing','11-3','Milestone',selectedBlock.stage11)">
                                                                                11.3 Thawing  
                                                                            </div>
                                                                        </div>
                                                                    </div> 
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage10" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                              
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/11.png" />
                                                            <div class="chain-label-in-progress">11. Vitrafy Controlled Biothaw</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/11.png" />
                                                            11. Vitrafy Controlled Biothaw
                                                        </div>
                                                    </div>

                                                    <!-- 12 -->
                                                    <div class="chain-row chain-row-item">
                                                        <!-- summary -->
                                                        <div v-if="selectedBlock.stage12" class="chain-label chain-label-complete">
                                                            <img @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover contractImage" src="../assets/images/contractIcons/12.png" />
                                                            <div @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover chain-label-complete">12. Transplant Completed</div>
                                                            <div @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover completedText">{{ selectedBlock.stage12 }}</div>

                                                            <!-- info box -->
                                                            <i @click="infoBoxClosed_12 = !infoBoxClosed_12" class="hover info_box_icon" v-bind:class="[infoBoxClosed_12 ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                            <div v-if="!infoBoxClosed_12">
                                                                <div id="collapse-1" style="float: left; width: 100%">
                                                                    <div style="height: 110px; position: absolute; left: -11px; top: 105px; width: 160px; background-color: white; border: 3px solid #00ad5b; border-left: 3px solid #fff; border-bottom: 3px solid #fff"></div>
                                                                    <div style="height: 59px;position: absolute;left: -11px;top: 207px;width: 160px;background-color: white;border-width: 3px;border-style: solid;border-color: rgb(0, 173, 91) rgb(0, 173, 91) rgb(255, 255, 255) rgb(255, 255, 255);border-image: initial;border: none;background-color: #fdfdfe;"></div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('12.1 Doctor, Patient & biological material identified','12-1','Milestone',selectedBlock.stage12)">
                                                                                12.1 Doctor, Patient & biological material <br />identified
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div style="float: left; width: 100%;">
                                                                        <div style="width: 33.3%; float: left;">
                                                                            <div class="info_boc_l1 info_box" @click="selectedMilestone('12.2 Transplant process','12-2','Milestone',selectedBlock.stage12)">
                                                                                12.2 Transplant process
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div v-else-if="selectedBlock.stage11" class="chain-label chain-label-complete">
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                            <img class="contractImage contractImageInProgress" src="../assets/images/contractIcons/12.png" />
                                                            <div class="chain-label-in-progress">12. Transplant</div>
                                                            <div class="inProgressText">In Progress</div>
                                                        </div>
                                                        <div v-else class="chain-label chain-label-disabled">
                                                            <!-- hide top of line -->
                                                            <div style="position: absolute; top: -16px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>
                                                            <!-- hide bottom of line -->
                                                            <div style="position: absolute; bottom: -26px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                           
                                                            <img class="contractImage contractImageNotActioned" src="../assets/images/contractIcons/12.png" />
                                                            12. Transplant
                                                        </div>
                                                        <!-- hide bottom of line -->
                                                        <div style="position: absolute; bottom: -8px; left: -19px; height: 20px; width: 20px; background-color: #fff;"></div>                                                        
                                                    </div>                                                

                                                    <div class="end-of-chain">END OF CHAIN</div>                                              
                                                </div>

                                            </div>
                                        </b-modal>

                                        <!-- milestone modal -->
                                        <b-modal id="milestone-modal" size="xl" v-bind:title="selectedMilestoneText" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                                            <div>
                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Process Type</b></td>
                                                        <td>{{ selectedMilestoneType }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Process ID</b></td>
                                                        <td>{{selectedBlock.displayid }}-{{ selectedMilestoneID }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Action Owner</b></td>
                                                        <td>Authorised User</td>
                                                    </tr>     
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Status</b></td>
                                                        <td v-if="processInProgress" class="milestoneS-status in-progres-status">IN PROGRESS</td>
                                                        <td v-else class="milestoneS-status">COMPLETED</td>
                                                    </tr>
                                                    <tr v-if="!processInProgress">
                                                        <td style="padding-right: 10px;"><b>Completion Data</b></td>
                                                        <td>{{ selectedMilestoneTimestamp }}</td>
                                                    </tr>
                                                </table>

                                                <div style="float:left; width:100%; margin-bottom: 10px;">
                                                    <hr />
                                                    <!-- google map (in progress) -->
                                                    <div v-if="processInProgress && locationMotSet" style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                                                        <BlockchainTrackingBlank ref="BlockchainTrackingBlank"/>
                                                    </div>

                                                    <!-- google map (complete) -->
                                                    <div v-else style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                                                        <BlockchainTracking ref="BlockchainTracking"/>
                                                    </div>

                                                    <!-- data -->
                                                    <div style="display: inline-block; width: 50%; padding-left: 20px; float: left;">

                                                        <!-- sections 1.1 (in progress) -->
                                                        <div v-if="processInProgress" class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">
                                                            <!-- location -->
                                                            <div class="chain-row chain-row-item">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/location.png" />
                                                                    <div class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                                                    <!-- <div class="hover completedText">Vitrafy Lab</div> -->

                                                                    <!-- info box -->
                                                                    <!-- <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i> -->
                                                                    <!-- <div v-if="!infoBoxClosed_location"> -->
                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                            
                                                                            <!-- form -->
                                                                            <b-form-group id="input-group-2" label="Description:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_location_description"
                                                                                placeholder="Description of the location"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Location:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                style="display: inline-block; width:360px;"
                                                                                v-model="process_location"
                                                                                placeholder="Start typing address"
                                                                                required
                                                                                ></b-form-input>
                                                                                <b-button v-if="!detectingLocation" variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" @click="detectLocation()">Detect</b-button>
                                                                                <b-button v-else variant="primary" class="btn-sm" style="float: right; height: 33.19px; width: 58.42px" disabled><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
                                                                            </b-form-group>
    
                                                                        </div>
                                                                    <!-- </div> -->
                                                                </div>
                                                            </div>

                                                            <!-- doctor details -->
                                                            <div class="chain-row chain-row-item">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/doctor.png" />
                                                                    <div class="hover chain-label-complete infoBoxLabel">Doctor Details</div>

                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                            
                                                                            <!-- form -->
                                                                            <b-form-group id="input-group-2" label="Title:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_title"
                                                                                placeholder="Enter title"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Surname:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_surname"
                                                                                placeholder="Enter surname"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Firstname:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_firstname"
                                                                                placeholder="Enter firstname"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_phone"
                                                                                placeholder="Enter phone number"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Email:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_email"
                                                                                placeholder="Enter email address"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Profession:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_profession"
                                                                                placeholder="Enter profession"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-2" label="Registration number:" label-for="input-2">
                                                                                <b-form-input
                                                                                id="input-2"
                                                                                v-model="process_doctor_reg_number"
                                                                                placeholder="Enter registration number"
                                                                                required
                                                                                ></b-form-input>
                                                                            </b-form-group>
                                                                            <b-form-group id="input-group-3" label="Registration status:" label-for="input-3">
                                                                                <b-form-select
                                                                                id="input-3"
                                                                                v-model="process_doctor_reg_status"
                                                                                :options="process_doctor_reg_status_options"
                                                                                required
                                                                                ></b-form-select>
                                                                            </b-form-group>

                                                                        </div>
                                                                    <!-- </div> -->
                                                                </div>
                                                            </div>

                                                            <div class="chain-row chain-row-item">
                                                                <b-button variant="primary" class="btn-sm" style="float: right; height: 33.19px;" v-b-modal="'process-commit-to-blockchain-modal'">Commit to Blockchain</b-button>
                                                            </div>

                                                        </div>

                                                        <!-- sections 4.2 (completed) -->
                                                        <div v-else class="chain infoBoxChain" style="float: left; margin-left: 20px; margin-right: 20px;">

                                                            <!-- location -->
                                                            <div class="chain-row chain-row-item">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/location.png" />
                                                                    <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover chain-label-complete infoBoxLabel">Location Information</div>
                                                                    <div @click="infoBoxClosed_location = !infoBoxClosed_location" class="hover completedText">Vitrafy Lab</div>

                                                                    <!-- info box -->
                                                                    <i @click="infoBoxClosed_1 = !infoBoxClosed_1" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_location ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                    <div v-if="!infoBoxClosed_location">
                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                            <!-- Info here -->

                                                                            <table class="blockchain-info-table">
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Description</b></td>
                                                                                    <td>Vitrafy Lab</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Address</b></td>
                                                                                    <td>45 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px; vertical-align: top;"><b>Coordinates</b></td>
                                                                                    <td>latitude: -37.530854124846904<br /> longitude: 143.84331081186326</td>
                                                                                </tr>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- doctor details -->
                                                            <div class="chain-row chain-row-item">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/doctor.png" />
                                                                    <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover chain-label-complete infoBoxLabel">Doctor Details</div>
                                                                    <div @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover completedText">Dr. Strange</div>

                                                                    <!-- info box -->
                                                                    <i @click="infoBoxClosed_doctor = !infoBoxClosed_doctor" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_doctor ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                    <div v-if="!infoBoxClosed_doctor">
                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                            
                                                                            <table class="blockchain-info-table">

                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Title:</b></td>
                                                                                    <td>Dr.</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Surname</b></td>
                                                                                    <td>Strange</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Firstname:</b></td>
                                                                                    <td>Stephen</td>
                                                                                </tr>                                                                            
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Phone:</b></td>
                                                                                    <td>+61 411 343 442</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Email:</b></td>
                                                                                    <td>stephen.strange@email.com</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Profession</b></td>
                                                                                    <td>Medical Doctor</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Registration number:</b></td>
                                                                                    <td>123456789</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Registration status:</b></td>
                                                                                    <td>Registered</td>
                                                                                </tr>
                                                                            </table>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- patient -->
                                                            <div class="chain-row chain-row-item">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/user.png" />
                                                                    <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover chain-label-complete infoBoxLabel">Patient Details</div>
                                                                    <div @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover completedText">Joe Citizen</div>

                                                                    <!-- info box -->
                                                                    <i @click="infoBoxClosed_patient = !infoBoxClosed_patient" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_patient ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                    <div v-if="!infoBoxClosed_patient">
                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                            
                                                                            <table class="blockchain-info-table">
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Title:</b></td>
                                                                                    <td>Mr.</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Firstname:</b></td>
                                                                                    <td>Joe</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Surname</b></td>
                                                                                    <td>Citizen</td>
                                                                                </tr>                                                                                                                                                        
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>DOB:</b></td>
                                                                                    <td>23/05/1975</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Gender:</b></td>
                                                                                    <td>Male</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Address:</b></td>
                                                                                    <td>5 Selkirk Drive, Wendouree VIC 3355 Australia</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Phone:</b></td>
                                                                                    <td>+61 456 345 345</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Email:</b></td>
                                                                                    <td>joe.citizen@email.com</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style="padding-right: 10px;"><b>Medical Info:</b></td>
                                                                                    <td><a href="#">Click to view details</a></td>
                                                                                </tr>
                                                                            </table>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- process -->
                                                            <div class="chain-row chain-row-item" style="width: 100%;">
                                                                <!-- summary -->
                                                                <div class="chain-label chain-label-complete">
                                                                    <!-- Icon and heading -->
                                                                    <img @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/process.png" />
                                                                    <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover chain-label-complete infoBoxLabel">Process Details</div>
                                                                    <div @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover completedText">4.2 Cryopreservation</div>

                                                                    <!-- info box -->
                                                                    <i @click="infoBoxClosed_process = !infoBoxClosed_process" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_process ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                    <div v-if="!infoBoxClosed_process">
                                                                        <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">

                                                                                <!-- checks -->
                                                                                <div class="process_heading">Prerequisite Checks</div>
                                                                                <div class="chain-row chain-row-item">
                                                                                    <!-- summary -->
                                                                                    <div class="chain-label chain-label-complete">
                                                                                        <!-- Icon and heading -->
                                                                                        <img @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/checks.png" />
                                                                                        <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover chain-label-complete infoBoxLabel">Milestones</div>
                                                                                        <div @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover completedText">3.2.5, 3.2.6, 3.2.7</div>

                                                                                        <!-- info box -->
                                                                                        <i @click="infoBoxClosed_sample_checks = !infoBoxClosed_sample_checks" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_checks ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                                        <div v-if="!infoBoxClosed_sample_checks">
                                                                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                                                

                                                                                                <table class="blockchain-info-table">
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.5 </b> <a href="#">MIoT cryopreservation device informed</a></td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.6 </b> <a href="#">Racking system and protocol selected</a></td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>3.2.7 </b> <a href="#">MIoT smart packaging device informed other devices</a></td>
                                                                                                    </tr>
                                                                                                </table>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- sample -->
                                                                                <div class="process_heading">Pre-Cryopreservation</div>
                                                                                <div class="chain-row chain-row-item">
                                                                                    <!-- summary -->
                                                                                    <div class="chain-label chain-label-complete">
                                                                                        <!-- Icon and heading -->
                                                                                        <img @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/sample.png" />
                                                                                        <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover chain-label-complete infoBoxLabel">Sample Details</div>
                                                                                        <div @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover completedText">Vitrafy 30mL Smart MIoT EVA Bag</div>

                                                                                        <!-- info box -->
                                                                                        <i @click="infoBoxClosed_sample = !infoBoxClosed_sample" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                                        <div v-if="!infoBoxClosed_sample">
                                                                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                                                

                                                                                                <table class="blockchain-info-table">
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px; vertical-align: top;"><b>Sample Description:</b></td>
                                                                                                        <td style="white-space: break-spaces;">Human peripheral blood, isolated T-cells in 10% DMSO media</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Sample Volume:</b></td>
                                                                                                        <td>20mL</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Package ID:</b></td>
                                                                                                        <td>12345-67890-12345b</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Package Type:</b></td>
                                                                                                        <td>Vitrafy 30mL Smart MIoT EVA Bag</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                    <td style="padding-right: 10px;"><b>Technical Info:</b></td>
                                                                                                        <td><a href="#">Click to view details</a></td>
                                                                                                    </tr>
                                                                                                </table>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- device -->
                                                                                <div class="process_heading">Cryopreservation </div>
                                                                                <div class="chain-row chain-row-item">
                                                                                    <!-- summary -->
                                                                                    <div class="chain-label chain-label-complete">
                                                                                        <!-- Icon and heading -->
                                                                                        <img @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/device.png" />
                                                                                        <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover chain-label-complete infoBoxLabel">Device Details</div>
                                                                                        <div @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover completedText">Cryopreservation Apparatus</div>

                                                                                        <!-- info box -->
                                                                                        <i @click="infoBoxClosed_device = !infoBoxClosed_device" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_device ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                                        <div v-if="!infoBoxClosed_device">
                                                                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                                                

                                                                                                <table class="blockchain-info-table">
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Device Name</b></td>
                                                                                                        <td>Vitrafy-00004</td>
                                                                                                    </tr>                                                                                                        
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Device ID:</b></td>
                                                                                                        <td>12345-76890-54321d</td>
                                                                                                    </tr>                                                                                                                                                
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Device Type:</b></td>
                                                                                                        <td>Cryopreservation Apparatus</td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Protocol</b></td>
                                                                                                        <td><a href="#">Click to view details</a></td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td style="padding-right: 10px;"><b>Schedule</b></td>
                                                                                                        <td><a href="#">Click to view details</a></td>
                                                                                                    </tr>
                                                                                                </table>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- reg -->
                                                                                <div class="process_heading">Regulatory</div>
                                                                                <div class="chain-row chain-row-item">
                                                                                    <!-- summary -->
                                                                                    <div class="chain-label chain-label-complete">
                                                                                        <!-- Icon and heading -->
                                                                                        <img @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover contractImage infoBoxImage" src="../assets/images/contractIcons/checks.png" />
                                                                                        <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover chain-label-complete infoBoxLabel">Regulatory compliance</div>
                                                                                        <div @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover completedText">FDA, TGA, EMA</div>

                                                                                        <!-- info box -->
                                                                                        <i @click="infoBoxClosed_sample_reg = !infoBoxClosed_sample_reg" class="hover info_box_icon infoBoxChevron" v-bind:class="[infoBoxClosed_sample_reg ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-up']"></i>
                                                                                        <div v-if="!infoBoxClosed_sample_reg">
                                                                                            <div id="collapse-1" class="infoBoxText" style="float: left; width: 100%">
                                                                                                

                                                                                                <table class="blockchain-info-table">
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>FDA </b> <a href="#">click to view pdf standards</a></td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>TGA </b> <a href="#">click to view pdf standards</a></td>
                                                                                                    </tr>
                                                                                                    <tr>
                                                                                                        <td><i class="fa-solid fa-check" style="color: green; padding-right: 10px;"></i> <b>EMA </b> <a href="#">click to view pdf standards</a></td>
                                                                                                    </tr>
                                                                                                </table>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>  
                                                </div>
                                            </div>
                                        </b-modal>

                                        <!-- Commit to blockchain modal -->
                                        <b-modal id="process-commit-to-blockchain-modal" title="Commit to Blockchain" @ok="processCommitToBlockchain">
                                            <div>
                                                <b-alert show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span style="padding-left: 10px;"><b>Warning Alert</b></span><br />This process is irreversible and will add an immutable record for this contract to the blockchain (test-network)</b-alert>
                                                Are you sure you want to commit the following data to the blockchain?
                                            </div>

                                            <div style="margin-top: 15px">
                                                <table class="blockchain-info-table">
                                                    <tr>
                                                        <td colspan="2">
                                                            <b>LOCATION INFORMATION</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Description</b></td>
                                                        <td>{{ process_location_description }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Address</b></td>
                                                        <td>{{ process_location }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <br />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            <b>DOCTOR DETAILS</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Title</b></td>
                                                        <td>{{ process_doctor_title }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Surname</b></td>
                                                        <td>{{ process_doctor_surname }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Firstname</b></td>
                                                        <td>{{ process_doctor_firstname }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Phone</b></td>
                                                        <td>{{ process_doctor_phone }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Email</b></td>
                                                        <td>{{ process_doctor_email }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Profession</b></td>
                                                        <td>{{ process_doctor_profession }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Registration number</b></td>
                                                        <td>{{ process_doctor_reg_number }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="padding-right: 10px;"><b>Registration status</b></td>
                                                        <td>{{ process_doctor_reg_status }}</td>
                                                    </tr>
                                                </table> 
                                            </div>

                                            <template #modal-footer="{ cancel, ok }">
                                                <b-button size="sm" variant="secondary" @click="cancel()">
                                                    Cancel
                                                </b-button>                    
                                                <b-button size="sm" variant="warning" @click="ok()">
                                                    Commit
                                                </b-button>
                                            </template>
                                        </b-modal>

                                        <!-- contract template details modal -->
                                        <b-modal id="contract-template-modal" size="lg" title="Template Details" ok-only ok-variant="secondary" button-size="sm" ok-title="Close">
                                            <div id="blockchain-data-loading-modal" style="display: block;">
                                                <div class="lds-facebook"><div></div><div></div><div></div></div>
                                                <!-- <div>Blockchain (LifeChain Private Network) processing...</div>                                                       -->
                                            </div>
                                            <div id="blockchain-modal" style="display: none;">

                                                <!-- tabs -->
                                            <b-tabs content-class="mt-3">
                                                <b-tab title="Design">

                                                <!-- Stages --> 
                                                <div class="design-stage-container" style="max-width: 400px;" v-for="stage in selectedBlock.TempData.stages" v-bind:key="stage.ID">
                                                    <div class="design-stage standard-stage" v-bind:class="{ 
                                                        'design-subprocess' : stage.stageType === 'subprocess', 
                                                        'initialization-stage' : stage.stageType === 'initialization', 
                                                        'completion-stage': stage.stageType === 'completion'}"
                                                        >
                                                        <div class="stage-menu">
                                                            <div>
                                                                <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret>
                                                                    <template #button-content>
                                                                        <font-awesome-icon icon="ellipsis-v" />
                                                                    </template>
                                                                    <b-dropdown-item href="#" v-b-modal="'edit-stage-modal'" @click="selectedStageForModal(stage)">Edit</b-dropdown-item>
                                                                    <b-dropdown-item href="#" v-b-modal="'delete-stage-modal'" @click="selectedStageForModal(stage)">Delete</b-dropdown-item>
                                                                </b-dropdown>
                                                            </div>

                                                        </div>
                                                        <div class="stage-badge"> {{ stage.stageType }}<br />{{ stage.stage }} </div>
                                                        <div style="padding-top: 20px">{{ stage.stageName }} </div>
                                                    </div>

                                                    <!-- links -->
                                                    <div v-if="stage.stageType != 'completion'" class="link-line" style="float: left; width: 100%; position: relative;">
                                                        <!-- link left -->
                                                        <div class="design-stage" style="padding: 0; border: 0; z-index:99">
                                                            <div style="width: 50%; border-right: 2px solid; padding: 30px; background-color: white;">
                                                                <div v-if="stage.subprocesses.length > 0" style="width: 100%; height: 50%; position: absolute; left: 0; bottom: -2px; background: white;"></div>
                                                                <font-awesome-icon v-if="stage.subprocesses.length == 0" style="position: absolute; bottom: -6px; right: 47%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                                            </div>
                                                        </div>
                                                        <!-- link right -->
                                                        <div v-if="stage.subprocesses.length > 0 || stage.id == selectedBlock.TempData.stages[selectedBlock.TempData.stages.length -1].id">
                                                            <div class="design-stage design-subprocess" style="padding: 0; border: 0; z-index:99">
                                                                <div style="width: 50%; border-left: 2px solid; padding: 30px; background-color: white; float: right;">
                                                                    <div style="width: 100%; height: 50%; position: absolute; left: 0; top: 0px; background: white;"></div>
                                                                    <font-awesome-icon style="position: absolute; bottom: -6px; right: 46%; font-size: 16px" icon="fa-solid fa-chevron-down" />
                                                                </div>
                                                            </div>
                                                            <div style="border-bottom: 2px solid; position: absolute; width: 100%; top: 50%;"></div>
                                                        </div>
                                                    </div>     

                                                    <!-- Subprocesses -->
                                                    <div class="design-stage-container" v-for="subprocess in stage.subprocesses" v-bind:key="subprocess.ID">
                                                        <div class="design-stage" v-bind:class="{ 'design-subprocess' : subprocess.stageType === 'subprocess'}">
                                                            <div class="stage-menu">
                                                                <div>
                                                                    <b-dropdown size="sm"  variant="link" toggle-class="text-decoration-none" no-caret>
                                                                        <template #button-content>
                                                                            <font-awesome-icon icon="ellipsis-v" />
                                                                        </template>
                                                                        <b-dropdown-item href="#" v-b-modal="'edit-stage-modal'" @click="selectedStageForModal(subprocess)">Edit</b-dropdown-item>
                                                                        <b-dropdown-item href="#" v-b-modal="'delete-stage-modal'" @click="selectedStageForModal(subprocess)">Delete</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </div>
                                                            </div>
                                                        <div class="stage-badge"> {{ subprocess.stageType }}<br />{{ subprocess.stage }} </div>
                                                        <div style="padding-top: 20px">{{ subprocess.stageName }} </div>
                                                        </div>

                                                        <!-- links -->
                                                        <div class="link-line" style="float: left; width: 100%; position: relative;">
                                                            <!-- link left -->
                                                            <div v-if="subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" class="design-stage" style="padding: 0; border: 0; z-index:99">
                                                                <div style="width: 50%; border-right: 2px solid; padding: 30px; background-color: white;">
                                                                    <div v-if="stage.subprocesses.length > 0" style="width: 100%; height: 50%; position: absolute; left: 0; top: 0px; background: white;"></div>
                                                                    <font-awesome-icon style="position: absolute; bottom: -6px; right: 47%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                                                </div>
                                                            </div>
                                                            <!-- link right -->
                                                            <div class="design-stage design-subprocess" style="padding: 0; border: 0; z-index:99">
                                                                <div style="width: 50%; border-left: 2px solid; padding: 30px; background-color: white; float: right;">
                                                                    <div v-if="stage.id != selectedBlock.TempData.stages[selectedBlock.TempData.stages.length -1].id && subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" style="width: 100%; height: 50%; position: absolute; left: 0; bottom: -2px; background: white;"></div>
                                                                    <font-awesome-icon v-if="stage.id == selectedBlock.TempData.stages[selectedBlock.TempData.stages.length -1].id || subprocess.id != stage.subprocesses[stage.subprocesses.length -1].id" style="position: absolute; bottom: -6px; right: 46%; font-size: 16px;" icon="fa-solid fa-chevron-down" />
                                                                </div>
                                                            </div>
                                                            <div v-if="subprocess.id == stage.subprocesses[stage.subprocesses.length -1].id" style="border-bottom: 2px solid; position: absolute; width: 100%; top: 50%;"></div>
                                                        </div>                               

                                                    </div> 

                                                </div>                                                

                                                                
                                                </b-tab>
                                                <b-tab title="Code (JSON)">

                                                    <!-- Code (JSON) -->
                                                    <pre> {{ selectedBlock.TempData }} </pre>

                                                </b-tab>                                            
                                            </b-tabs>                                            

                                            </div>
                                        </b-modal>

                                    </div>
                                    <!-- END blockchain table -->

                                </div>
                            </div>

                            <!-- Blockchain V2 (Current Version) -->
                            <div v-if="selectedSideNav.label == 'Human' || selectedSideNav.label == 'Bovine' || selectedSideNav.label == 'Aquaculture'" class="page-content">
                                
                                <h1 class="h2 page-section-title">

                                    <!-- <svg style="margin-top: -5px;" focusable="false" aria-hidden="true" width="38" height="38" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="chakra-icon chakra-icon css-1q7v2v0"><g><mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16" style="mask-type: alpha;"><rect width="16" height="16" fill="currentColor"></rect></mask><g mask="url(#mask0_1612_19788)"><path d="M12.6665 6.00002C12.0332 6.00002 11.4832 5.81113 11.0165 5.43335C10.5498 5.05558 10.2387 4.5778 10.0832 4.00002H5.89984C5.77761 4.46669 5.54706 4.86946 5.20817 5.20835C4.86928 5.54724 4.4665 5.7778 3.99984 5.90002V10.0834C4.57761 10.2389 5.05539 10.55 5.43317 11.0167C5.81095 11.4834 5.99984 12.0334 5.99984 12.6667C5.99984 13.4 5.73873 14.0278 5.2165 14.55C4.69428 15.0722 4.0665 15.3334 3.33317 15.3334C2.59984 15.3334 1.97206 15.0722 1.44984 14.55C0.927615 14.0278 0.666504 13.4 0.666504 12.6667C0.666504 12.0334 0.855393 11.4834 1.23317 11.0167C1.61095 10.55 2.08873 10.2389 2.6665 10.0834V5.90002C2.08873 5.74446 1.61095 5.43335 1.23317 4.96669C0.855393 4.50002 0.666504 3.95558 0.666504 3.33335C0.666504 2.60002 0.927615 1.97224 1.44984 1.45002C1.97206 0.927798 2.59984 0.666687 3.33317 0.666687C3.95539 0.666687 4.49984 0.855576 4.9665 1.23335C5.43317 1.61113 5.74428 2.08891 5.89984 2.66669H10.0832C10.2387 2.08891 10.5498 1.61113 11.0165 1.23335C11.4832 0.855576 12.0332 0.666687 12.6665 0.666687C13.3998 0.666687 14.0276 0.927798 14.5498 1.45002C15.0721 1.97224 15.3332 2.60002 15.3332 3.33335C15.3332 4.06669 15.0721 4.69446 14.5498 5.21669C14.0276 5.73891 13.3998 6.00002 12.6665 6.00002ZM3.33317 14C3.69984 14 4.01373 13.8667 4.27484 13.6C4.53595 13.3334 4.6665 13.0222 4.6665 12.6667C4.6665 12.3 4.53595 11.9861 4.27484 11.725C4.01373 11.4639 3.69984 11.3334 3.33317 11.3334C2.97761 11.3334 2.6665 11.4639 2.39984 11.725C2.13317 11.9861 1.99984 12.3 1.99984 12.6667C1.99984 13.0222 2.13317 13.3334 2.39984 13.6C2.6665 13.8667 2.97761 14 3.33317 14ZM3.33317 4.66669C3.69984 4.66669 4.01373 4.53613 4.27484 4.27502C4.53595 4.01391 4.6665 3.70002 4.6665 3.33335C4.6665 2.96669 4.53595 2.6528 4.27484 2.39169C4.01373 2.13058 3.69984 2.00002 3.33317 2.00002C2.97761 2.00002 2.6665 2.13058 2.39984 2.39169C2.13317 2.6528 1.99984 2.96669 1.99984 3.33335C1.99984 3.70002 2.13317 4.01391 2.39984 4.27502C2.6665 4.53613 2.97761 4.66669 3.33317 4.66669ZM12.6665 15.3334C11.9332 15.3334 11.3054 15.0722 10.7832 14.55C10.2609 14.0278 9.99984 13.4 9.99984 12.6667C9.99984 11.9334 10.2609 11.3056 10.7832 10.7834C11.3054 10.2611 11.9332 10 12.6665 10C13.3998 10 14.0276 10.2611 14.5498 10.7834C15.0721 11.3056 15.3332 11.9334 15.3332 12.6667C15.3332 13.4 15.0721 14.0278 14.5498 14.55C14.0276 15.0722 13.3998 15.3334 12.6665 15.3334ZM12.6665 14C13.0332 14 13.3471 13.8667 13.6082 13.6C13.8693 13.3334 13.9998 13.0222 13.9998 12.6667C13.9998 12.3 13.8693 11.9861 13.6082 11.725C13.3471 11.4639 13.0332 11.3334 12.6665 11.3334C12.2998 11.3334 11.9859 11.4639 11.7248 11.725C11.4637 11.9861 11.3332 12.3 11.3332 12.6667C11.3332 13.0222 11.4637 13.3334 11.7248 13.6C11.9859 13.8667 12.2998 14 12.6665 14ZM12.6665 4.66669C13.0332 4.66669 13.3471 4.53613 13.6082 4.27502C13.8693 4.01391 13.9998 3.70002 13.9998 3.33335C13.9998 2.96669 13.8693 2.6528 13.6082 2.39169C13.3471 2.13058 13.0332 2.00002 12.6665 2.00002C12.2998 2.00002 11.9859 2.13058 11.7248 2.39169C11.4637 2.6528 11.3332 2.96669 11.3332 3.33335C11.3332 3.70002 11.4637 4.01391 11.7248 4.27502C11.9859 4.53613 12.2998 4.66669 12.6665 4.66669Z" fill="currentColor"></path></g></g></svg>                                     -->

                                    <!-- humna -->
                                    <svg v-if="selectedSideNav.label == 'Human'" style="margin-top: -5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" focusable="false" aria-hidden="true" height="30" width="30" xmlns="http://www.w3.org/2000/svg" class="chakra-icon css-1p95nbn"><path d="M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-223.1L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6l29.7 0c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9 232 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0z"></path></svg>
                                    <!-- bovine -->
                                    <svg v-if="selectedSideNav.label == 'Bovine'" style="margin-top: -5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 640 512" focusable="false" aria-hidden="true" height="42" width="42" xmlns="http://www.w3.org/2000/svg" class="chakra-icon css-1p95nbn"><path d="M96 224l0 32 0 160c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88.2c9.9 6.6 20.6 12 32 16.1l0 24.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24.2c11.4-4 22.1-9.4 32-16.1l0 88.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L272 64l-16 0-64 0-48 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"></path></svg>
                                    <!-- aquaculture -->
                                    <svg v-if="selectedSideNav.label == 'Aquaculture'" style="margin-top: -5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" focusable="false" aria-hidden="true" height="42" width="42" xmlns="http://www.w3.org/2000/svg" class="chakra-icon css-1p95nbn"><path d="M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path></svg>

                                    <span>{{ selectedSideNav.label }}</span>
                                </h1>
                                <hr class="page-section-hr"/>
                                <div style="margin-bottom: 25px;"></div>

                                <!-- <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-cube" style="padding-right: 10px;"></i> {{ selectedSideNav.label }}</h1>
                                </div> -->

                                <div style="float: left; width: 100%">
                                    
                                    <BlockchainDashboard :showNFT="showNFT" :type="selectedSideNav.sublabel" :subtype="selectedSideNav.label" :incomingBlockchainCache="bcCache" ref="BlockchainDashboard"/>

                                </div>
                            </div>

                            <!-- Contract Designer -->
                            <div v-if="selectedSideNav.label == 'Contract Designer'" class="page-content">

                                <!-- <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><font-awesome-icon icon="fa-solid fa-file-signature" /> Workflow Builder</h1>
                                </div> -->
                                <h1 class="h2 page-section-title">
                                    <font-awesome-icon icon="fa-solid fa-file-signature" style="font-size: 25px;" />
                                    <span>Workflow Builder</span>
                                </h1>
                                <hr class="page-section-hr"/>                                
                                <div style="margin-bottom: 25px;"></div>

                                <div style="float: left; width: 100%">
                                    <designer ref="designer"/>
                                </div>
                            </div>

                            <!-- Ethereum -->
                            <div v-if="selectedSideNav.label == 'Finance'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <!-- <h1 class="h2"><font-awesome-icon icon="fa-brands fa-ethereum" /> Finance</h1> -->
                                    <h1 class="h2"><i class="fa-solid fa-money-bill-trend-up" style="padding-right: 10px;"></i> Finance</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <nft ref="nft"/>

                                </div>
                            </div>

                            <!-- NFC Dev -->
                            <div v-if="selectedSideNav.label == 'NFC'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-brands fa-nfc-symbol" style="padding-right: 10px;"></i> NFC</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <NFC ref="nfc"/>

                                </div>
                            </div>

                            <!-- Machine Learning -->
                            <div v-if="selectedSideNav.label == 'Machine Learning'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-microchip" style="padding-right: 10px;"></i> Machine Learning</h1>
                                </div>
                                <div id="ml2-container" style="float: left; width: 100%">
                                    
                                    <ML2 ref="ml2"/>

                                </div>
                            </div>

                            <!-- Machine Learning (old) -->
                            <div v-if="selectedSideNav.label == 'Machine Learning old'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-microchip" style="padding-right: 10px;"></i> Machine Learning v2</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <ML_old ref="ml_old"/>

                                </div>
                            </div>

                            <!-- OCR Function -->
                            <div v-if="selectedSideNav.label == 'Machine Vision'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-eye" style="padding-right: 10px;"></i> Machine Vision</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <OCR ref="OCR"/>

                                </div>
                            </div>

                            <!-- Machine Learning -->
                            <div v-if="selectedSideNav.label == 'ML Training'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-microchip" style="padding-right: 10px;"></i> ML Training</h1>
                                </div>
                                <div id="ml2-container" style="float: left; width: 100%">
                                    
                                    <ML_Training ref="ml_training"/>

                                </div>
                            </div>                        

                            <!-- XR -->
                            <div v-if="selectedSideNav.label == 'XR'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-vr-cardboard" style="padding-right: 10px;"></i> XR</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <XRDashboard ref="XRDashboard"/>

                                </div>
                            </div>

                            <!-- Quantum  -->
                            <div v-if="selectedSideNav.label == 'Quantum'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-atom" style="padding-right: 10px;"></i> Quantum Computing</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <QuantumDashboard ref="QuantumDashboard"/>

                                </div>
                            </div>                        

                            <!-- Contract Teseting -->
                            <div v-if="selectedSideNav.label == 'Contract Testing'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-file-signature" style="padding-right: 10px;"></i> Contract Testing</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <ContractTesting ref="ContractTesting"/>

                                </div>
                            </div>

                            <!-- BlockchainTest -->
                            <div v-if="selectedSideNav.label == 'Blockchain Test'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-cube" style="padding-right: 10px;"></i> Blockchain Test</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <BlockchainTestDashboard ref="BlockchainTestDashboard"/>

                                </div>
                            </div>
                            
                            <!-- BlockchainIntegrationTestDashboard -->
                            <div v-if="selectedSideNav.label == 'Blockchain Integration Test'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-cube" style="padding-right: 10px;"></i> Blockchain Integration Test</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <BlockchainIntegrationTestDashboard ref="BlockchainIntegrationTestDashboard"/>

                                </div>
                            </div>
                            
                            <!-- BlockchainIntegrationTestDashboard 2 -->
                            <div v-if="selectedSideNav.label == 'Blockchain Integration Test 2'" class="page-content">
                                <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                    <h1 class="h2"><i class="fa-solid fa-cube" style="padding-right: 10px;"></i> Blockchain Integration Test 2</h1>
                                </div>
                                <div style="float: left; width: 100%">
                                    
                                    <BlockchainIntegrationTestDashboard2 ref="BlockchainIntegrationTestDashboard2"/>

                                </div>
                            </div>                             

                        </div>
                    </main>

                </div>
            </div>

            <!-- Footer -->
            <footer id="footer"
                    class="footer mt-auto main-footer"
                    style="min-height:36px; color:#fff; font-size:14px; padding:0; display:flex; align-items:center;">
                <div class="container"
                    style="width:100%; display:flex; align-items:center; justify-content:space-between; padding-top:0; padding-bottom:0;">
                    <span id="footer-version" style="flex:1; text-align:left; padding-bottom: 8px;">Version 0.1.0</span>
                    <span id="footer-website" style="flex:1; text-align:center; padding-bottom: 8px;">www.vitrafy.com</span>
                    <span id="footer-copyright" style="flex:1; text-align:right; padding-bottom: 8px;">
                    {{`Copyright © ${new Date().getFullYear()} Vitrafy Life Sciences Ltd`}}
                    </span>
                </div>
                <!-- keep this OUTSIDE the flex row so it doesn’t affect vertical centering -->
                <speech-recognition ref="SpeechRecognition" />
            </footer>

        </div>
    </div>
</template>

<script>
    import UserInfoStore from '../app/user-info-store';
    import DeviceCard from '@/components/DeviceCard.vue';
    import DeviceCardVirtual from '@/components/DeviceCardVirtual.vue';
    import AddGoogleMap from '@/components/AddGoogleMap.vue';
    import Designer from '@/components/Designer.vue';
    import SpeechRecognition from '@/components/SpeechRecognition.vue';
    import Nft from '@/components/Nft.vue';
    import NFC from '@/components/NFC.vue';
    import BlockchainTracking from '@/components/BlockchainTracking.vue';
    import BlockchainTrackingBlank from '@/components/BlockchainTrackingBlank.vue';
    import Dashboard from '@/components/Dashboard.vue';
    import LifeLinkDashboard from '@/components/LifeLInkDashboard.vue';
    import WorkflowDashboard from '@/components/WorkflowDashboard.vue';
    import ML_old from '@/components/ML/ML_old.vue';
    import OCR from '@/components/ML/OCR.vue';
    import ML2 from '@/components/ML/ML2.vue';
    import ML_Training from '@/components/ML/ML_Training.vue';
    import BlockchainDashboard from '@/components/Blockchain/BlockchainDashboard.vue';
    import XRDashboard from '@/components/XR/XRDashboard.vue';
    import QuantumDashboard from '@/components/Quantum/QuantumDashboard.vue';
    import BlockchainTestDashboard from '@/components//BlockchainTest/BlockchainTestDashboard.vue';
    import BlockchainIntegrationTestDashboard from '@/components//BlockchainTest/BlockchainIntegrationTestDashboard.vue';
    import BlockchainIntegrationTestDashboard2 from '@/components//BlockchainTest/BlockchainIntegrationTestDashboard2.vue';
    import Wallet from '@/components/FinTech/Wallet.vue';
    /*import DeviceDashboard from '@/components/DeviceDashboard/DeviceDashboard.vue';*/
    import ContractTesting from '@/components/Blockchain/ContractTesting.vue';
    // import NFTVideoTest from '@/components/Blockchain/NFTVideoTest.vue';
    // import NFTVideoModal from '@/components/Blockchain/NFTVideoModal.vue'; 
    // import RegisterDevice from './RegisterDevice.vue';

    export default {
        name: 'Home',
        components: {
            DeviceCard,
            DeviceCardVirtual,
            AddGoogleMap,
            Designer,
            SpeechRecognition,
            Nft,
            NFC,
            BlockchainTracking,
            BlockchainTrackingBlank,
            Dashboard,
            LifeLinkDashboard,
            WorkflowDashboard,
            ML_old,
            OCR,
            ML2,
            ML_Training,
            BlockchainDashboard,
            XRDashboard,
            QuantumDashboard,
            Wallet,
            /*DeviceDashboard,*/
            ContractTesting,
            // NFTVideoTest,
            // NFTVideoModal,
            // RegisterDevice,
            BlockchainTestDashboard,
            BlockchainIntegrationTestDashboard,
            BlockchainIntegrationTestDashboard2
        },
        data: function () {
            return {
                selectedApp: null,
                sessionExpiredTimer: null,
                dismissSecs: 30,
                dismissCountDown: 0,
                pageLoading: true,
                showLoader: true,
                loadingImageIsVisible: false,
                loadingTextIsVisible: false,
                version: "1.4.0",
                showWallet: true,
                showNFT: false,
                animalSubItemsExpanded: false,
                sideNavNew: [],
                sideNav: [],
                sideNavHome: [
                    { id: 1, labelText: "Home", label: "Dashboard", icon: "fa-solid fa-house-user", voice: "loading your personal dashboard", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 6, labelText: "Admin", label: "Intelligence",icon: "fa-solid fa-wand-magic-sparkles", voice: "loading contract designer", enabled: true, restricted: true, selected: false, subItems: [
                        // { id: 6, label: "Dashboard ",icon: "fa-solid fa-file-signature", voice: "loading contract designer", enabled: true,  restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                        { id: 7, label: "User Management", icon: "fa-solid fa-money-bill-trend-up", voice: "Finance", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                        { id: 8, label: "System Settings", icon: "fa-brands fa-nfc-symbol", voice: "N F C", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    ], subItemsExpanded: false }                    
                ],
                sideNavLifeLink: [
                    { id: 1, labelText: "Dashboard  ", label: "Dashboard  ", icon: "fa-solid fa-house-user", voice: "loading your personal dashboard", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 2, labelText: "Devices", label: "Devices", icon: "fa-solid fa-house-user", voice: "loading your personal dashboard", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },                 
                    { id: 3, labelText: "Tracking", label: "Tracking", icon: "fa-solid fa-map", voice: "displaying current global locations of Life Link devices", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                ],                          
                sideNavOld: [
                    { id: 1, labelText: "Dashboard   ", label: "Dashboard   ", icon: "fa-solid fa-house-user", voice: "loading your personal dashboard", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    // { id: 1, labelText: "Home", label: "Dashboard", icon: "fa-solid fa-house-user", voice: "loading your personal dashboard", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    // { id: 2, labelText: "LifeLink", label: "LifeLink", icon: "fa-solid fa-vector-square", voice: "showing life link device status information", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    // { id: 3, labelText: "Tracking", label: "Tracking", icon: "fa-solid fa-map", voice: "displaying current global locations of Life Link devices", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 4, labelText: "Blockchain v1", label: "Blockchain v1", icon: "fa-solid fa-cube", voice: "connecting to private blockchain", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 5, labelText: "Blockchain", label: "Blockchain", icon: "fa-solid fa-cubes", voice: "connecting to private blockchain", enabled: true, restricted: true, selected: false, subItems: [
                        { id: 1, sublabel: "Human", label: "Human", icon: "fa-solid fa-cube", voice: "connecting to private blockchain", enabled: true, restricted: true, selected: false },
                        // { id: 1, sublabel: "Animal", label: "Animal", icon: "fa-solid fa-cube", voice: "connecting to private blockchain", enabled: true, restricted: true, selected: false },
                        { id: 2, sublabel: "Human", label: "Bovine", icon: "fa-solid fa-cube", voice: "connecting to private blockchain", enabled: true, restricted: true, selected: false },
                        { id: 3, sublabel: "Animal Health", label: "Aquaculture", icon: "fa-solid fa-cube", voice: "connecting to private blockchain", enabled: true, restricted: true, selected: false }
                    ], subItemsExpanded: false },
                    //{ id: 6, label: "Contract Designer",icon: "fa-solid fa-file-signature", voice: "loading contract designer", enabled: true,  restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 7, label: "Finance", icon: "fa-solid fa-money-bill-trend-up", voice: "Finance", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 8, label: "NFC", icon: "fa-brands fa-nfc-symbol", voice: "N F C", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 9, label: "Machine Learning", icon: "fa-solid fa-microchip", voice: "Machine Learning", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 10, labelText: "Machine Learning old", label: "Machine Learning old", icon: "fa-solid fa-microchip", voice: "Machine Learning", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 11, label: "ML Training", icon: "fa-solid fa-microchip", voice: "Machine Learning Training", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 12, label: "Machine Vision", icon: "fa-solid fa-eye", voice: "Machine Vision", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 13, label: "XR", icon: "fa-solid fa-mask", voice: "Extended reality", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    /*{ id: 13, label: "Device Dashboard", icon: "fa-solid fa-gauge-high", voice: "Device Dashboard", enabled: false, restricted: false, selected: false, subItems: [], subItemsExpanded: false },*/
                    //{ id: 14, label: "Contract Testing", icon: "fa-solid fa-file-signature", voice: "Device Dashboard", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //{ id: 15, label: "Quantum", icon: "fa-solid fa-atom", voice: "Quantum Computing", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 16, labelText: "Machine Learning old", label: "Machine Learning old", icon: "fa-solid fa-cube", voice: "Blockchain Test", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 17, labelText: "Machine Learning old", label: "Machine Learning old", icon: "fa-solid fa-cube", voice: "Blockchain Integration Test", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    { id: 19, labelText: "Blockchain", label: "Blockchain Integration Test 2", icon: "fa-solid fa-cube", voice: "Blockchain Integration Test 2", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    // { id: 6, labelText: "Intelligence", label: "Intelligence",icon: "fa-solid fa-wand-magic-sparkles", voice: "loading contract designer", enabled: true, restricted: true, selected: false, subItems: [
                    //     { id: 6, label: "Contract Designer",icon: "fa-solid fa-file-signature", voice: "loading contract designer", enabled: true,  restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 7, label: "Finance", icon: "fa-solid fa-money-bill-trend-up", voice: "Finance", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 8, label: "NFC", icon: "fa-brands fa-nfc-symbol", voice: "N F C", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 9, label: "Machine Learning", icon: "fa-solid fa-microchip", voice: "Machine Learning", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 11, label: "ML Training", icon: "fa-solid fa-microchip", voice: "Machine Learning Training", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 12, label: "Machine Vision", icon: "fa-solid fa-eye", voice: "Machine Vision", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 13, label: "XR", icon: "fa-solid fa-mask", voice: "Extended reality", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    //     { id: 15, label: "Quantum", icon: "fa-solid fa-atom", voice: "Quantum Computing", enabled: true, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                    // ], subItemsExpanded: false },
                    { id: 3, labelText: "Workflow Builder", label: "Contract Designer", icon: "fa-solid fa-file-signature", voice: "displaying current global locations of Life Link devices", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },                
                    { id: 31, labelText: "Workflow Settings", label: "Workflow Settings", icon: "fa-solid fa-file-signature", voice: "displaying current global locations of Life Link devices", enabled: true, restricted: false, selected: false, subItems: [], subItemsExpanded: false },                
                ],
                ML_Only_sideNav: [
                    { id: 9, label: "Machine Learning", icon: "fa-solid fa-microchip", voice: "Machine Learning", enabled: true, restricted: false, selected: true },
                ],
                selectedSideNav: { id: null, label: null, icon: null, enabled: null, restricted: null, selected: null },
                dashboardDynamicGreeting: "not set",
                detectingLocation: false,
                process_location_description: null,
                process_location: null,
                process_doctor_name: null,
                process_doctor_title: null,
                process_doctor_firstname: null,
                process_doctor_surname: null,
                process_doctor_phone: null,
                process_doctor_email: null,
                process_doctor_profession: null,
                process_doctor_reg_number: null,
                process_doctor_reg_status: null,
                process_doctor_reg_status_options: [{ text: 'Select One', value: null }, 'Registered', 'Not registered'],
                locationMotSet: true,
                processInProgress: false,
                process_1_1: true,
                process_1_2: false,
                infoBoxClosed_location: true,
                infoBoxClosed_patient: true,
                infoBoxClosed_doctor: true,
                infoBoxClosed_sample: true,
                infoBoxClosed_sample_checks: true,
                infoBoxClosed_sample_reg: true,
                infoBoxClosed_device: true,
                infoBoxClosed_process: true,
                infoBoxClosed_1: true,
                infoBoxClosed_2: true,
                infoBoxClosed_3: true,
                infoBoxClosed_4: true,
                infoBoxClosed_5: true,
                infoBoxClosed_6: true,
                infoBoxClosed_7: true,
                infoBoxClosed_8: true,
                infoBoxClosed_9: true,
                infoBoxClosed_10: true,
                infoBoxClosed_11: true,
                infoBoxClosed_12: true,
                restoreVoiceTestLoading: false,
                voiceTestLoading: false,
                voiceChangeLoading: false,
                lifeLinkView: "registered",
                lifeLinkViewOptions: [{ value: 'type', text: 'Type'}, { value: 'location', text: 'Location' }, { value: 'registered', text: 'Registered' }],
                loadingVoices: false,
                voices: [],
                voiceEngineSelected: 'neural',
                voiceEngineOptions: [{ item: 'neural', name: 'Neural' }, { item: 'standard', name: 'Standard' }],
                voiceLanguageSelected: '',
                voiceLanguageOptions: [],
                voiceSelected: '',
                voiceOptions: [],
                smartContractName: 'CONTRACT NAME',
                userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
                userInfo: UserInfoStore.state.cognitoInfo,
                restrictedLifeLinkUser: UserInfoStore.state.restrictedLifeLinkUser,
                userName: "user",
                info: null,
                apiData: "testData",
                items: [],
                virtualDevices: [],
                devicesFromDB: [],
                registeredDevices: [],
                unregisteredDevices: [],
                testDevices: [],
                blockchain: [],
                blockchainInProgress: [],
                blockchainInProgressCount: '',
                blockchainCompleted: [],
                blockchainCompletedCount: '',
                blockchainTemplates: [],
                blockchainTemplatesCount: '',
                testData: [],
                selectedBlock: {TempData: {stages: {}}},
                contractName: 'new contract',
                contractApplication: null,
                contractApplicationOptions: [{ text: 'Select Application', value: null }, 'CAR-T'],
                contractTemplate: null,
                contractTemplateOptions: [{ text: 'Select Template', value: null }, 'CAR-T Test Template 1'],
                sensorData: [],
                trackingDataAll: [],
                trackingDataRpi4G: [],
                trackingDataRpi4G02: [],
                autofetch: false,
                active: false,
                tabTrackingDataAll: '',
                tabTrackingDataRpi4G : '',
                tabTrackingDataRpi4G02 : '',
                tab: 0,
                fetchTrackingData: false,
                fetchSensorData: false,
                fetchDeviceData: false,
                designermodalOpen: false,
                errorDetails: null,
                audioPath: "https://mcaloon.org/voice/",
                AIChecked: false,
                voiceText: "Hi, my name is Lily. I'm the LifeChain Virtual Assistant. How can I help you today?",
                selectedMilestoneText: null,
                selectedMilestoneID: null,
                selectedMilestoneType: null,
                selectedMilestoneTimestamp: null,
                deviceTempAndFlow: [
                    {
                        name: "Vitrafy-00001",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00002",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00004",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00005",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00006",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00010",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00007",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00009",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    },
                    {
                        name: "Vitrafy-00011",
                        temp: null,
                        belowZero: false,
                        flow: null,
                        device_operation_status: null
                    }
                ],
                DeviceCurrentTemp0004: null,
                DeviceFlowActual0004: null,
                sideNavToggle: false,
                showBlockchainCollapsedSubitems: false,
                bcCache: [],
                loadingText: "Initialising LifeChain...",
                loadingTextPhrases: [
                    "Loading... please wait.",
                    "Fetching data...",
                    "Processing your request...",
                    "Almost there...",
                    "Hang tight, we're working on it...",
                    "Just a moment...",
                    "Loading content...",
                    "Please be patient...",
                    "Gathering information...",
                    "This won't take long...",
                    "Loading resources...",
                    "Hold on, we're almost done...",
                    "Please wait while we load...",
                    "Loading data, please wait...",
                    "Preparing your experience...",
                    "Stay tuned...",
                    "We're getting things ready...",
                    "Just a bit more loading...",
                    "Thank you for your patience...",
                    "Loading, thank you for waiting...",
                    "Connecting to the blockchain...",
                    "Verifying transactions...",
                    "Syncing with the network...",
                    "Fetching blockchain data...",
                    "Processing blockchain requests...",
                    "Loading blockchain ledger...",
                    "Validating blocks...",
                    "Updating blockchain state...",
                    "Connecting to blockchain nodes...",
                    "Loading smart contracts...",
                    "Interacting with the blockchain...",
                    "Waiting for blockchain confirmation...",
                    "Loading decentralized data...",
                    "Fetching blockchain transactions...",
                    "Retrieving blockchain records...",
                    "Checking blockchain integrity...",
                    "Updating blockchain ledger...",
                    "Connecting to the decentralized network...",
                    "Loading blockchain information...",
                    "Ensuring blockchain security..."                    
                ]               
            };
        },
        methods: {
            changeApp(app) {
                localStorage.selectedApp = app;
                //window.location.reload(); // reloads current URL
                window.location.assign(`${window.location.origin}/${app}`);
            },
            toggleSideNav() {
                console.log("toggle sidenav");

                this.sideNavToggle = !this.sideNavToggle;
                console.log(this.sideNavToggle);

                if(this.sideNavToggle) {
                    console.log("sideNavToggle = closed " + this.sideNavToggle);

                    for(var i = 0; i < this.sideNav.length; i++) {
                        for(var x = 0; x < this.sideNav[i].subItems.length; x++) {
                            if(this.sideNav[i].subItems[x].selected == true) {
                                this.sideNav[i].selected = true;
                            }
                        }
                        this.sideNav[i].subItemsExpanded = false;
                    }

                } else {
                    console.log("sideNavToggle = open " + this.sideNavToggle);

                    for(i = 0; i < this.sideNav.length; i++) {
                        for(x = 0; x < this.sideNav[i].subItems.length; x++) {
                            if(this.sideNav[i].subItems[x].selected == true) {
                                this.sideNav[i].selected = false;
                                this.sideNav[i].subItemsExpanded = true;
                            }
                        }
                    }

                }
            },
            animalNavClick() {
                this.animalSubItemsExpanded = !this.animalSubItemsExpanded;
            },
            cardNavClick(label) {
                console.log("HERE " + label);

                // LifeLInk
                if(label == "LifeLink") {
                    // set nav to LifeLink
                    //this.sideNav = this.sideNavLifeLLink;

                    // set active nav to LifeLink Dashboard
                    for(var i = 0; i < this.sideNav.length; i++) {
                        if (this.sideNav[i].label == "Dashboard  ") {
                            this.sideNav[i].selected = true;
                        }
                    }

                    // set page to LifeLink Dashboard
                    this.selectedSideNav.label = "Dashboard  ";
                }

                // Workflow
                if(label == "Human") {
                    // set nav to LifeLink
                    //this.sideNav = this.sideNavOld;
                    //this.sideNav = this.sideNavOld;

                    // set active nav to LifeLink Dashboard
                    for(var j = 0; j < this.sideNav.length; j++) {
                        if (this.sideNav[j].label == "Dashboard   ") {
                            this.sideNav[j].selected = true;
                        }
                    }

                    // set page to LifeLink Dashboard
                    this.selectedSideNav.label = "Dashboard   ";
                }                
            },
            sideNavClick(label) {
                console.log("sidenav clicked: " + label);

                // disabled nav items
                if(label == "Intelligence" || label == "Workflow Settings"){
                    return "ready";
                }

                // Home APP
                // -------------------------
                if(label == "Dashboard"){
                    //this.sideNav = this.sideNavHome;
                    this.selectedSideNav.label = "Dashboard";
                    for(var w = 0; w < this.sideNav.length; w++) {
                        if (this.sideNav[w].label == "Dashboard") {
                            this.sideNav[w].selected = true;
                        } else {
                            this.sideNav[w].selected = false;
                        }
                    }                        
                    return "ready";
                }                    

                // LifeLink APP
                // -------------------------
                // LifeLink Dashboard
                if(label == "Dashboard  "){
                    //this.sideNav = this.sideNavLifeLLink;
                    this.selectedSideNav.label = "Dashboard  ";
                    for(var q = 0; q < this.sideNav.length; q++) {
                        if (this.sideNav[q].label == "Dashboard  ") {
                            this.sideNav[q].selected = true;
                        } else {
                            this.sideNav[q].selected = false;
                        }
                    }                        
                    return "ready";
                }      

                // LifeLink Devices
                if(label == "Devices"){
                    for(var j = 0; j < this.sideNav.length; j++) {
                        if (this.sideNav[j].label == "Devices") {
                            this.sideNav[j].selected = true;
                        } else {
                            this.sideNav[j].selected = false;
                        }
                    }                       
                    console.log("Devices clicked - SHOW LIFELINK");
                    this.selectedSideNav.label = "LifeLink";
                    this.getAllDevicesFromDB();
                    this.getLifeLinkData();
                    this.fetchDeviceData = true;
                    return "ready";
                }
                
                // LifeLink Dashboard
                if(label == "Tracking"){
                    this.selectedSideNav.label = "Tracking";
                    for(var e = 0; e < this.sideNav.length; e++) {
                        if (this.sideNav[e].label == "Tracking") {
                            this.sideNav[e].selected = true;
                        } else {
                            this.sideNav[e].selected = false;
                        }
                    }                        
                    return "ready";
                }                    

                // OLD
                // -------------------------
                this.showBlockchainCollapsedSubitems = false;    
                var saveSideNavLocation = true;
                this.fetchDeviceData = false; 

                if(label == "Blockchain" || label == "Intelligence") {
                    saveSideNavLocation = false;
                }

                // cater for new subitmes
                if(label == "Human" || label == "Animal Health") {
                    this.sideNav[4].subItemsExpanded = true;
                }

                for(var i = 0; i < this.sideNav.length; i++) {
                    for(var x = 0; x < this.sideNav[i].subItems.length; x++) {
                        if (this.sideNav[i].subItems[x].label == label) { 
                            this.sideNav[i].subItems[x].selected = true;
                            this.selectedSideNav = this.sideNav[i].subItems[x];
                        } else {
                            if (saveSideNavLocation) {
                                localStorage.nav = label;
                            }                              
                            this.sideNav[i].subItems[x].selected = false;
                        }
                    }

                    if (this.sideNav[i].label == label) {
                        if(label == "Blockchain" || label == "Intelligence") {
                            // open/close blockchain menu
                            if(!this.sideNavToggle) {
                                this.sideNav[i].selected = true;  
                                if(this.sideNav[i].subItemsExpanded) {
                                    this.sideNav[i].subItemsExpanded = false;
                                } else {
                                    this.sideNav[i].subItemsExpanded = true;
                                }
                            } else {
                                // UP TO HERE
                                console.log("sidenave collapsed and blockchain clicked!");
                                this.sideNav[i].selected = true;
                                this.showBlockchainCollapsedSubitems = true;
                            }
                        } else {
                            this.sideNav[i].selected = true;
                            if (saveSideNavLocation) {
                                localStorage.nav = label;
                            }                               
                            this.selectedSideNav = this.sideNav[i];
                        } 

                        this.playSound("play", this.selectedSideNav.voice);

                        if(this.selectedSideNav.label == "LifeLink") { 
                            this.getAllDevicesFromDB();
                            this.getLifeLinkData();
                            this.fetchDeviceData = true;    
                        }
                    
                        if(this.selectedSideNav.label == "Blockchain v1") { 
                            this.getBlockchain();
                        }
                    } else { 
                        this.sideNav[i].selected = false;
                    }
                }

                // cater for new subitmes
                if(this.sideNavToggle) {
                    if(label == "Human" || label == "Animal Health") {
                        this.sideNav[4].selected = true;
                    }
                }              

                this.closeNav();
            },
            processCommitToBlockchain() {
                console.log("processCommitToBlockchain clicked");
            },
            detectLocation() {
                console.log("detectLocation clicked");
                this.detectingLocation = true;  

                setTimeout(() => {
                    this.detectingLocation = false;    
                    this.locationMotSet = false;
                    this.process_location = "45 Selkirk Drive, Wendouree VIC 3355 Australia"                    
                }, 1000);
            },
            async assistantTestModal() {
                this.loadingVoices = true;
                console.log("assistantTestModal clicked!");

                let headers = {
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };                       

                try {
                    const response = await this.$http.get(
                        "https://mcaloon.org/getLanguages",
                        {headers: headers}
                    );
                    
                    this.voices = response.data.Voices; 
                    var languageList = [];

                    // create distinct list of available Languages
                    this.voices.forEach(function(voice) {
                        var item = {
                            value: voice.LanguageCode,
                            text: voice.LanguageName + " (" + voice.LanguageCode + ")",
                        }
                        
                        // add first item
                        if(languageList.length < 1) {
                            languageList.push(item);
                        }

                        // only add if the Language does not already exist
                        var exists = false;
                        languageList.forEach(function(i) {
                            if(item.value == i.value) {
                                exists = true;
                            }
                        })
                        if(!exists) {
                            languageList.push(item);
                        }
                    })

                    // adjust LanguageName (move English to the start if it exists) 
                    languageList.forEach(function(item) {
                        var nameArr = item.text.split(" ");
                        var exists = false;
                        var arrIndex = 0;
                        
                        for(var i = 0; i < nameArr.length; i++) {
                            if(nameArr[i] == "English") {
                                exists = true;
                                arrIndex = i;
                            } 
                        }

                        if(exists) {
                            nameArr.splice(arrIndex, 1);
                            var nameAdjusted = "English,";
                            nameArr.forEach(function(item) {
                                nameAdjusted = nameAdjusted + " " + item;
                            });
                            item.text = nameAdjusted;
                        }
                    });

                    // alphabetically order languageList
                    languageList.sort((a, b) => a.text.localeCompare(b.text))

                    // assign to observable for select component
                    this.voiceLanguageOptions = languageList;

                    // loading complete
                    this.loadingVoices = false;

                    this.voiceSelected = localStorage.voiceSelected;
                    this.voiceLanguageSelected = localStorage.voiceLanguageSelected;

                    this.getVoices();
                    //this.voiceSelected = "Olivia,neural";
                    //this.voiceEngineSelected  = "neural";

                } catch (error) {
                    console.log(error);
                }
            },
            getVoices() {
                var voiceList = [];
                var lc = this.voiceLanguageSelected;

                // get voices for selected language
                this.voices.forEach(function(voice) {
                    if(voice.LanguageCode == lc) {
                        voice.SupportedEngines.forEach(function(engine) {
                            var item = {
                                value: voice.Id + "," + engine,
                                text: voice.Name + " (" + engine + ")"
                            }
                            if(engine == "standard") {
                                item.text = voice.Name;
                            }
                            voiceList.push(item);
                        })
                    }
                })

                // assign values elements
                this.voiceOptions = voiceList;
                //this.voiceSelected = this.voiceOptions[0].value;

                // if current voice not in list select the top one
                var voiceInList = false;

                for(var i = 0; i < this.voiceOptions.length; i++) {
                    console.log("-----");
                    console.log(this.voiceSelected + " " + this.voiceOptions[i].value);
                    if(this.voiceSelected == this.voiceOptions[i].value) {
                        voiceInList = true;
                    }
                }

                if(!voiceInList) {
                    this.voiceSelected = this.voiceOptions[0].value;
                }
            },
            getEngine() {
                this.voiceEngineSelected = this.voiceSelected.split(",")[1];
            },
            async sendInfo(block, designerModal) {
                console.log("Inside sendinfo block")
                console.log("block = " + block.ID);

                // reset info boxes
                this.infoBoxClosed_1 = true;
                this.infoBoxClosed_2 = true;
                this.infoBoxClosed_3 = true;
                this.infoBoxClosed_4 = true;
                this.infoBoxClosed_5 = true;
                this.infoBoxClosed_6 = true;
                this.infoBoxClosed_7 = true;
                this.infoBoxClosed_8 = true;
                this.infoBoxClosed_9 = true;
                this.infoBoxClosed_10 = true;
                this.infoBoxClosed_11 = true;
                this.infoBoxClosed_12 = true;

                await this.ReadAssetHistory(block);
                
                this.selectedBlock = block;

                // block history
                console.log(block.history);

                document.getElementById("blockchain-data-loading-modal").style.display = 'none';
                document.getElementById("blockchain-modal").style.display = 'block';

                if(designerModal) {
                    console.log("designer modal opened");
                    this.designermodalOpen = true;
                    console.log(this.selectedBlock.TempData);

                    var data = this.selectedBlock.TempData;

                    console.log("data = ");
                    console.log(data.uuid);
                    console.log(data.stages[0].stageType);

                    //this.selectedBlock.design = JSON.parse(this.selectedBlock.TempData);
                    //console.log(this.selectedBlock.design);
                } else {
                    console.log("block modal opened and NOT designer modal");
                }

            },
            selectedMilestone(milstoneText, milestoneID, milestoneType, milestoneTimestamp, inprogress) {
                // reset input fields
                this.locationMotSet = true;
                this.detectingLocation = false,
                this.process_location_description = null;
                this.process_location = null;
                this.process_doctor_name = null;
                this.process_doctor_title = null;
                this.process_doctor_surname = null;
                this.process_doctor_firstname = null;
                this.process_doctor_phone = null;
                this.process_doctor_email = null;
                this.process_doctor_profession = null;
                this.process_doctor_reg_number = null;
                this.process_doctor_reg_status = null;
                
                // check if process is in progress
                if(inprogress) {
                    this.processInProgress = true;
                } else {
                    this.processInProgress = false;
                }
                
                // close any expanded dropdowns
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // load selected data into modal
                this.selectedMilestoneText = milstoneText;
                this.selectedMilestoneID = milestoneID;
                this.selectedMilestoneType = "Subprocess"; // overriddden
                this.selectedMilestoneTimestamp = milestoneTimestamp;
            },
            lifeLinkViewChnage() {
                localStorage.lifeLinkView = this.lifeLinkView;
            },
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )},
            async getLifeLinkData() {
                //console.log("Get lifelink data...")
                try {
                    let url = "https://t0wxzdk096.execute-api.ap-southeast-2.amazonaws.com/beta/lifelink";
                    let headers = {
                        'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                    };

                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );
                    this.items = response.data.Items;

                    for (var i = 0; i < this.items.length; i++) {
                        

                    //filter on registered devices
                    // Preload list
                   /* this.registeredDevices = [
                        "BioThaw-Vitrafy-00004",
                        "Vitrafy-00001",
                        "Vitrafy-00002",
                        "Vitrafy-00003",
                        "Vitrafy-00004",
                        "Vitrafy-00005",
                        "Vitrafy-00006",
                        "Vitrafy-00007",
                        "Vitrafy-00009",
                        "Vitrafy-00011",
                        "Vitrafy-HP00001",
                        "Vitrafy-00010",
                        "Packaging Device 1",
                        "Packaging Device 2",
                        "Packaging Device 3",
                        'MIoT-PROTO-1',
                        'MIoT-PROTO-2'
                    ];*/

                    
                    // test devices
                        var testDevices = [
                            // "raspi2",
                            // "VLSENGNB011",
                            // "VLSENGNB017",
                            // "raspi-4G-02",
                            // "raspi5",
                            // "MIoT-PROTO-1",
                            // "DRB-PC",
                            // "MIoT-PROTO-2",
                        ];
                    
                        this.$set(this.items[i], 'testDevice', false)
                        if(testDevices.includes(this.items[i].id)) {
                            this.$set(this.items[i], 'testDevice', true)
                        }

                        // sensor device status
                        this.$set(this.items[i], 'sensorDevice', false)
                        if (this.items[i].id == "raspi2") {
                            this.$set(this.items[i], 'sensorDevice', true)
                        }
                        if (this.items[i].id == "raspi5") {
                            this.$set(this.items[i], 'sensorDevice', true)
                        }                        

                        // details
                        this.$set(this.items[i], 'details', "Cryopreservation Apparatus")
                        if (this.items[i].id == "raspi2" || this.items[i].id == "raspi5") {
                            this.$set(this.items[i], 'details', "MIoT Test Device (sensor)")
                        }
                        if (this.items[i].id == "raspi-4G-02") {
                            this.$set(this.items[i], 'details', "MIoT Test Device (4G)")
                        }                    
                        if (this.items[i].id == "VLSENGNB011") {
                            this.$set(this.items[i], 'details', "Simon's Laptop")
                        }if (this.items[i].id == "VLSENGNB017") {
                            this.$set(this.items[i], 'details', "Borhan's Laptop")
                        }if (this.items[i].id == "DRB-PC") {
                            this.$set(this.items[i], 'id', 'MIoT-PROTO-2')  // Change its name to something more meaningful
                            this.$set(this.items[i], 'details', "MIoT Sim Prototype Device") // Set its description
                        }if (this.items[i].id == "MIoT-PROTO-1") {
                            this.$set(this.items[i], 'details', "MIoT Sim Prototype Device") // Set its description
                        }

                        // online
                        var currentTime = new Date().getTime();
                        var diff = (currentTime - this.items[i].deviceTimestamp) / 1000;
                        this.$set(this.items[i], 'diff', diff)
                        var online = true;
                        var offline = false;

                        // if no response after 3min device is considered offline
                        if (diff > 180) {
                            online = false;
                            offline = true;
                        }
                        this.$set(this.items[i], 'online', online)
                        this.$set(this.items[i], 'offline', offline)
                        if (this.items[i].id == "Vitrafy-00010") {
                            console.log("Manually setting online for 10")
                            this.items[i].offline=false;
                            this.items[i].online=true;
                        }
                        
                        // deviceCPU
                        this.items[i].deviceCPU = Math.round(this.items[i].deviceCPU * 10) / 10

                        // deviceMEM
                        var deviceMEM = (100 / this.items[i].deviceTotalMem) * this.items[i].deviceUsedMem
                        deviceMEM = Math.round(deviceMEM * 10) / 10
                        this.$set(this.items[i], 'deviceMEM', deviceMEM)

                        // Sensor Data
                        if (this.items[i].id == "raspi2" || this.items[i].id == "raspi5") {
                            var sensorDetails = this.items[i].deviceTempData.split(" ");
                            var sensorData = sensorDetails[1] + "C / " + sensorDetails[2] + "%";
                            this.SensorData = sensorData;
                            this.items[i].SensorTemp = sensorDetails[1];
                            this.items[i].SensorRH = sensorDetails[2];
                            var sensorDataTimestamp = sensorDetails[0];
                            this.$set(this.items[i], 'sensorData', sensorData)
                            this.$set(this.items[i], 'sensorDataTimestamp', sensorDataTimestamp)
                            var d = new Date();
                            var seconds = Math.round(d.getTime() / 1000);
                            var sensorTimeDiff = seconds - sensorDataTimestamp;
                            this.$set(this.items[i], 'sensorTimeDiff', sensorTimeDiff)
                            this.$set(this.items[i], 'seconds', seconds)
                        } else {
                            this.$set(this.items[i], 'sensorData', '');
                        }

                        // check if LifeLink is up to date
                        this.$set(this.items[i], 'lifeLinkUpToDate', true)
                        if(this.items[i].lifelinkVersion != '0.2.1 alpha') {
                            this.items[i].lifeLinkUpToDate = false;
                            this.items[i].lifelinkVersion = '0.1.8 alpha';
                        }

                        // rename laptop
                        // if (this.items[i].id == "VLSENGNB011") {
                        //     this.items[i].id = "Raspberry-Pi-1";
                        // }

                        // convert pi's
                        if (this.items[i].id == "raspi2") {
                            this.items[i].id = "Packaging Device 2";
                        }
                        if (this.items[i].id == "raspi-4G-02") {
                            this.items[i].id = "Packaging Device 1";
                        }
                        if (this.items[i].id == "raspi5") {
                            this.items[i].id = "Packaging Device 3";
                        }                        

                        // Add location to each device and Long/Lat coords
                        if(this.items[i].id == "BioThaw-Vitrafy-00004")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Lab');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Vitrafy-00001")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Engineering');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Vitrafy-00002")
                        {
                            this.$set(this.items[i], 'location', 'BioBridge Global (USA)');
                            this.$set(this.items[i], 'coords', {lat: 29.486533958316652, lng: -98.53972095398235,});
                        }
                        if(this.items[i].id == "Vitrafy-00003"){
                            this.$set(this.items[i], 'location', 'BioBridge Global (USA)');
                            this.$set(this.items[i], 'coords', {lat: 29.486533958316652, lng: -98.53972095398235,});
                        }
                        if(this.items[i].id == "Vitrafy-00004")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Engineering');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Vitrafy-00005")
                        {
                            this.$set(this.items[i], 'location', 'Huon Aquaculture (Tasmania)');
                            this.$set(this.items[i], 'coords', {lat: -42.77597315561563, lng: 147.05388827190774});
                        }
                        if(this.items[i].id == "Vitrafy-00006")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Lab');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Vitrafy-00007")
                        {
                            this.$set(this.items[i], 'location', 'IMV Technologies (France)');
                            this.$set(this.items[i], 'coords', {lat: 48.6528386, lng: 1.8353597});
                        }
                        if(this.items[i].id == "Vitrafy-00009")
                        {
                            this.$set(this.items[i], 'location', 'Select Sires International (USA)');
                            this.$set(this.items[i], 'coords', {lat: 40.1811541, lng: -83.2097349,});
                        }
                        if(this.items[i].id == "Vitrafy-00010")
                        {
                            this.$set(this.items[i], 'location', 'BioBridge Global (USA)');
                            this.$set(this.items[i], 'coords', {lat: 29.486533958316652, lng: -98.53972095398235,});
                        }
                        if(this.items[i].id == "Vitrafy-00011")
                        {
                            this.$set(this.items[i], 'location', 'IMV Technologies (France)');
                            this.$set(this.items[i], 'coords', {lat: 48.6528386, lng: 1.8353597});
                        }
                        if(this.items[i].id == "Vitrafy-HP00001")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Engineering');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Packaging Device 1")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Design Lab');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "Packaging Device 2")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Design Lab');
                            // this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                            this.$set(this.items[i], 'coords', {lat: null, lng: null});
                            this.$set(this.items[i], 'map_zoom_level', 17);
                        }
                        if(this.items[i].id == "Packaging Device 3")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Engineering');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "VLSENGNB011")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Office');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "VLSENGNB017")
                        {
                            this.$set(this.items[i], 'location', 'Vitrafy Office');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }
                        if(this.items[i].id == "MIoT-PROTO-1" || this.items[i].id == "MIoT-PROTO-2")
                        {
                            this.$set(this.items[i], 'location', 'Global');
                            this.$set(this.items[i], 'coords', {lat: -37.53092219073088, lng: 143.84338591371284});
                        }

                        // convert timestamp
                        var convertedTimestamp = new Date(this.items[i].deviceTimestamp);
                        this.$set(this.items[i], 'convertedTimestamp', convertedTimestamp);

                        // find diff in seconds 
                        var lastCommunicationSeconds = Math.round(Date.now() / 1000) - Math.round(this.items[i].deviceTimestamp / 1000)
                        if(lastCommunicationSeconds < 1) {lastCommunicationSeconds = 3;}
                        this.$set(this.items[i], 'lastCommunicationSeconds', lastCommunicationSeconds);

                        // format diff in seconds
                        this.$set(this.items[i], 'formattedLastCommunicationSeconds', this.timeCalculator(lastCommunicationSeconds).replace('secondago', 'second ago'));

                    }

                    // reorder devices by name (id)
                    this.items.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })

                    // move "Packaging Device 3" to the end of the items array (for UI)
                    var index = null;
                    var packagingDevice3 = null;
                    for(i = 0; i < this.items.length; i++) {
                        if(this.items[i].id == "Packaging Device 3") {
                            index = i;
                            packagingDevice3 = this.items[i];
                        }
                    }
                    this.items.splice(index, 1);
                    this.items.push(packagingDevice3);

                    // hide loading spinner and display dashboard
                    document.getElementById("lifelink-loading").style.display = 'none';
                    document.getElementById("lifelink-container").style.display = 'block';

                    // get machine temp data for specific devices (if online!);
                    for (i = 0; i < this.items.length; i++) {
                        //console.log("Getting machine data for: ", this.items[i].id, " ", this.items[i])
                        if(this.items[i].id == "Vitrafy-00001" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00001');
                        }
                        if(this.items[i].id == "Vitrafy-00002" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00002');
                        }
                        if(this.items[i].id == "Vitrafy-00004" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00004');
                        }
                        if(this.items[i].id == "Vitrafy-00005" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00005');
                        }
                        if(this.items[i].id == "Vitrafy-00006" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00006');
                        }
                        if(this.items[i].id == "Vitrafy-00007" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00007');
                        }
                        if(this.items[i].id == "Vitrafy-00009" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00009');
                        }
                        if(this.items[i].id == "Vitrafy-00010" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00010');
                        }
                        if(this.items[i].id == "Vitrafy-00011" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00011');
                        }
                        if(this.items[i].id == "Vitrafy-HP00001" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-HP00001');
                        }                                                                      
                    }

                    // Hardcoded registered device list (used while getAllDevicesFromDB is suppressed)
                    this.registeredDevices = [
                        "Vitrafy-00001",
                        "Vitrafy-00002",
                        "Vitrafy-00003",
                        "Vitrafy-00004",
                        "Vitrafy-00005",
                        "Vitrafy-00006",
                        "Vitrafy-00007",
                        "Vitrafy-00009",
                        "Vitrafy-00011",
                        "Vitrafy-HP00001",
                        "Vitrafy-00010",
                        "Packaging Device 1",
                        "Packaging Device 2",
                        "Packaging Device 3",
                        'MIoT-PROTO-1',
                        'MIoT-PROTO-2'
                    ];

                    var filteredItems = [];

                    for (var x = 0; x < this.items.length; x++) {
                        if(this.registeredDevices.includes(this.items[x].id)) {
                            filteredItems.push(this.items[x])
                        }
                    }

                    this.items = filteredItems;

                    // Add CASA test device to items
                    this.items.push({
                        id: "CASA-01",
                        testDevice: true,
                        details: "CASA (Computer-Assisted Sperm Analysis) System",
                        location: "Vitrafy Design Lab",
                        coords: {lat: -37.53092219073088, lng: 143.84338591371284},                    
                        online: true,
                        offline: false,                             
                        deviceCPU: 22.03,
                        deviceDateTime: "2025-04-11T08:51:50.233Z",
                        deviceFreeMem: 23.605055488,
                        deviceTempData: "",
                        deviceTimestamp: 1744361510233,
                        deviceTotalMem: 34.024419328,
                        deviceUptime: "3 hours, 1 minute, 23 seconds",
                        deviceUsedMem: 10.419363839999999,
                        lifelinkVersion: "0.2.1 alpha",
                        utcTimeStamp: 1744361514,
                        convertedTimestamp: new Date(),
                        formattedLastCommunicationSeconds: "3 seconds ago",
                    });

                    this.items.forEach(item => {
                        if(item.id == "Vitrafy-00008") {
                            item.location = "Vitrafy Engineering";
                        }
                        item.testDevice = false;
                    });

                    // add to test devices
                    this.items.forEach(item => {
                        if (item.id === "CASA-01" 
                            || item.id === "Packaging Device 3"
) {
                            item.testDevice = true;
                        }
                    });

                    // add to registered devices (for filter)
                    this.items.forEach(item => {
                        if (item.id === "CASA-01") {
                            item.registered = true;
                        }
                    });                    


                } catch (error) {
                    console.log(error);
                }
            },
            async getAllDevicesFromDB()
            {
                // API is currently returning null — suppressed until endpoint is fixed
                return;

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                var data = { "endpoint": "/api/devices/" };

                data = JSON.stringify(data);

                try
                {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    this.devicesFromDB = response.data
                    
                    // Load Device registration status from DB
                    this.unregisteredDevices = [];
                    this.registeredDevices = [];
                    for (var devicesLoop = 0; devicesLoop < this.devicesFromDB.length; devicesLoop++)
                    {
                        if(this.devicesFromDB[devicesLoop].IsRegistered == 1) this.registeredDevices.push(this.devicesFromDB[devicesLoop].FriendlyID);
                        if(this.devicesFromDB[devicesLoop].IsRegistered == 0 && this.devicesFromDB[devicesLoop].RegistrationComplete == 0) this.unregisteredDevices.push(this.devicesFromDB[devicesLoop]);
                    }
                }
                catch (error) {
                    console.log(error);
                }
            },
            async getMachineTempData(id) {
                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                var data = {
                    "endpoint": "/api/devices/" + id + "/data?mode=stream"
                };

                data = JSON.stringify(data);
                
                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    console.log("Machine data for: ", id, " | data: ", response.data);
                    if (this.items.filter(device => device.id == id)[0].online && !response.data) {
                        // TODO: Remove cheap hack: Device is active, but we have no data for it, set the device to inactive
                        this.items.filter(device => device.id == id)[0].online = false;
                        this.items.filter(device => device.id == id)[0].offine = true;
                    }
                    else {
                        for (var i = 0; i < response.data.length; i++) {
                            if(response.data[i].length > 0 ) {
                                var element = response.data[i];

                                if (element[0].TagID == "analogs_lc_lrt_scaled") {
                                    var temp = element[0].TagValue.toFixed(1);
                                    
                                    if(id == 'Vitrafy-00001') {
                                        this.deviceTempAndFlow[0].temp = temp;
                                        this.deviceTempAndFlow[0].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00002') {
                                        this.deviceTempAndFlow[1].temp = temp;
                                        this.deviceTempAndFlow[1].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00004') {
                                        this.deviceTempAndFlow[2].temp = temp;
                                        this.deviceTempAndFlow[2].belowZero = (temp < 1)
                                    }
                                    
                                    if(id == 'Vitrafy-00005') {
                                        this.deviceTempAndFlow[3].temp = temp;
                                        this.deviceTempAndFlow[3].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00006') {
                                        this.deviceTempAndFlow[4].temp = temp;
                                        this.deviceTempAndFlow[4].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00007') {
                                        this.deviceTempAndFlow[6].temp = temp;
                                        this.deviceTempAndFlow[6].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00009') {
                                        this.deviceTempAndFlow[7].temp = temp;
                                        this.deviceTempAndFlow[7].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00010') {
                                        this.deviceTempAndFlow[5].temp = temp;
                                        this.deviceTempAndFlow[5].belowZero = (temp < 1)
                                    }
                                    if(id == 'Vitrafy-00011') {
                                        this.deviceTempAndFlow[8].temp = temp;
                                        this.deviceTempAndFlow[8].belowZero = (temp < 1)
                                    }
                                }

                                if (element[0].TagID == "pids_lc_flow_pid_pv") {
                                    var deviceFlowActual = element[0].TagValue.toFixed(1);

                                    if(id == 'Vitrafy-00001') this.deviceTempAndFlow[0].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00002') this.deviceTempAndFlow[1].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00004') this.deviceTempAndFlow[2].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00005') this.deviceTempAndFlow[3].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00006') this.deviceTempAndFlow[4].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00007') this.deviceTempAndFlow[6].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00009') this.deviceTempAndFlow[7].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00010') this.deviceTempAndFlow[5].flow = deviceFlowActual;
                                    if(id == 'Vitrafy-00011') this.deviceTempAndFlow[8].flow = deviceFlowActual;
                                }
                                var me = this;
                                if (element[0].TagID == "operation_global_operationdescription") {
                                    var deviceStatus = element[0].stringvalue;

                                    for (var itemsCounter = 0; itemsCounter < me.items.length; itemsCounter++){
                                        if(id == me.items[itemsCounter].id) me.items[itemsCounter].device_operation_status = deviceStatus;
                                    }
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            timeCalculator: function(seconds) {
                let y = Math.floor(seconds / 31536000);
                let mo = Math.floor((seconds % 31536000) / 2628000);
                let d = Math.floor(((seconds % 31536000) % 2628000) / 86400);
                let h = Math.floor((seconds % (3600 * 24)) / 3600);
                let m = Math.floor((seconds % 3600) / 60);
                let s = Math.floor(seconds % 60);

                let yDisplay = y > 0 ? y + (y === 1 ? " year, " : " years, ") : "";
                let moDisplay = mo > 0 ? mo + (mo === 1 ? " month, " : " months, ") : "";
                let dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
                let hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
                let mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes, ") : "";
                let sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds ") : "";
                return yDisplay + moDisplay + dDisplay + hDisplay + mDisplay + sDisplay + "ago";
            },
            async getBlockchain() {
                this.errorDetails = null;
                this.blockchain = [];
                this.blockchainInProgress = [];
                this.blockchainCompleted = [];
                this.blockchainTemplates= [];

                let headers = {
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.get(
                        "https://mcaloon.org/GetAllAssets",
                        {headers: headers}
                    );
                    this.blockchain = response.data.body;
                    
                    console.log(this.blockchain);

                    // filter blockchain
                    var temp = [];
                    var ts;
                    var tsa;

                    for (var i = 0; i < this.blockchain.length; i++) {
                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        this.blockchain[i].datetime = ts;

                        temp.push(this.blockchain[i])

                        var idt = this.blockchain[i].ID.toString().split(':');
                        this.blockchain[i].displayid = idt[0];
                        this.blockchain[i].TimeStamp = idt[1];
                        this.blockchain[i].TimeStampEpoch = idt[1];
                        this.blockchain[i].name = idt[2];

                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        // tsa = ts.toString().split('GMT');
                        // ts = tsa[0];
                        // this.blockchain[i].TimeStamp = ts;

                        tsa = ts.toLocaleString('en-AU').toUpperCase();
                        var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                        this.blockchain[i].TimeStamp = tsb.replace(',', '');                    

                        // create text version of current state
                        if(this.blockchain[i].State == "0") {
                            this.blockchain[i].StateText = "1. Doctor Patient Identification (in progress)";
                            this.blockchain[i].stateProgress = 0;
                        }
                        if(this.blockchain[i].State == "1") {
                            this.blockchain[i].StateText = "2. Patient Collection (in progress)";
                            this.blockchain[i].stateProgress = 8.3;
                        }
                        if(this.blockchain[i].State == "2") {
                            this.blockchain[i].StateText = "3. Isolation Leukapheresis (in progress)";
                            this.blockchain[i].stateProgress = 16.6;
                        }
                        if(this.blockchain[i].State == "3") {
                            this.blockchain[i].StateText = "4. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 24.9;
                        }        
                        if(this.blockchain[i].State == "4") {
                            this.blockchain[i].StateText = "5. Specialised Logistics (in progress)";
                            this.blockchain[i].SensorData = "21";
                            this.blockchain[i].stateProgress = 33.2;
                        }       
                        if(this.blockchain[i].State == "5") {
                            this.blockchain[i].StateText = "6. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 41.5;
                        }
                        if(this.blockchain[i].State == "6") {
                            this.blockchain[i].StateText = "7. Differentiation Transformation (in progress)";
                            this.blockchain[i].stateProgress = 49.8;
                        }
                        if(this.blockchain[i].State == "7") {
                            this.blockchain[i].StateText = "8. Expansion (in progress)";
                            this.blockchain[i].stateProgress = 58.1;
                        }    
                        if(this.blockchain[i].State == "8") {
                            this.blockchain[i].StateText = "9. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 66.4;
                        }    
                        if(this.blockchain[i].State == "9") {
                            this.blockchain[i].StateText = "10. Specialised Logistics (in progress)";
                            this.blockchain[i].stateProgress = 74.7;
                        }    
                        if(this.blockchain[i].State == "10") {
                            this.blockchain[i].StateText = "11. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 83;
                        }    
                        if(this.blockchain[i].State == "11") {
                            this.blockchain[i].StateText = "12. Transplant (in progress)";
                            this.blockchain[i].stateProgress = 91.3;
                        }    
                        if(this.blockchain[i].State == "COMPLETE") {
                            this.blockchain[i].StateText = "Smart Contract Completed";
                            this.blockchain[i].stateProgress = 100;
                        }                                                                                                                                                                            
                    }

                    this.blockchain = temp;

                    // reorder devices by creation time
                    this.blockchain.sort(function(a, b){
                        if(a.TimeStampEpoch > b.TimeStampEpoch) { return -1; }
                        if(a.TimeStampEpoch < b.TimeStampEpoch) { return 1; }
                        return 0;
                    })

                    // split blockchain into "In Progress" and "Completed"
                    for (i = 0; i < this.blockchain.length; i++) {
                        if(this.blockchain[i].State != "template") {
                            //if(this.blockchain[i].State > "11" || this.blockchain[i].Owner == "Vitrafy") {
                            if(this.blockchain[i].State == "COMPLETE" || this.blockchain[i].Owner == "Vitrafy" || this.blockchain[i].Owner == "vitrafy") {

                                // remove some of the test contracts 
                                var hideCOntractList = [
                                    "test 123",
                                    "test",
                                    "test phoebe",
                                    "demo 1",
                                    "Eli test",
                                    "test111",
                                    "Eli Test",
                                    "test 123123123",
                                    "123"
                                ]

                                if(!hideCOntractList.includes(this.blockchain[i].name)) {
                                    this.blockchainCompleted.push(this.blockchain[i]);
                                }
                            } else {
                                // DISABLED
                                this.blockchainInProgress.push(this.blockchain[i]);
                            }

                            // FOR TESTING
                            //this.blockchainInProgress.push(this.blockchain[i]);

                        } else {
                            //this.blockchain[i].TempData = JSON.stringify(this.blockchain[i].TempData);

                            try {
                                this.blockchain[i].TempData = JSON.parse(this.blockchain[i].TempData);
                            } catch(err) {
                                console.log(err);
                            }

                            this.blockchainTemplates.push(this.blockchain[i]);
                        }
                    }
                    
                    this.blockchainInProgressCount = "In Progress (" + this.blockchainInProgress.length + ")";
                    this.blockchainCompletedCount = "Completed (" + this.blockchainCompleted.length + ")";
                    this.blockchainTemplatesCount = "Templates (" + this.blockchainTemplates.length + ")";

                    console.log("blockchainInProgress = " + this.blockchainInProgress.length);
                    console.log("blockchainCompleted = " + this.blockchainCompleted.length);                

                    document.getElementById("blockchain-data-loading").style.display = 'none';
                    document.getElementById("blockchain-table").style.display = 'block';

                    // hide blockchain error message
                    document.getElementById("blockchain-data-loading-error").style.display = 'none';
                } catch (error) {
                    console.log(error);
                    document.getElementById("blockchain-data-loading").style.display = 'none';
                    document.getElementById("blockchain-data-loading-error").style.display = 'block';
                    this.errorDetails = error;
                }            
            },
            async CreateAsset() {
                // hide table show loading spinner 
                document.getElementById("blockchain-data-loading").style.display = 'block';
                document.getElementById("blockchain-table").style.display = 'none';
    
                var blockId = this.uuidv4();
                
                var timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.contractName;

                var data = {
                    "ID": blockId,
                    "TimeStamp": timestamp,
                    "State": "0",
                    "Owner": "Vitrafy (version 2)",
                    "User": this.userInfo.username,
                    "TempData": ""
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/CreateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }            
            },
            blockchainStageComplete: async function(block) {
                // hide table show loading spinner 
                document.getElementById("blockchain-data-loading").style.display = 'block';
                document.getElementById("blockchain-table").style.display = 'none';

                console.log('blockchainStageComplete button clicked!');  
                var timestamp = new Date().getTime();

                // get latest sensor data
                console.log("waiting for sensor data");
                var latestSensorData = await this.getLatestSensorData();
                latestSensorData = latestSensorData.split(" ");
                latestSensorData = latestSensorData[0] + " " + latestSensorData[1] + "C " + latestSensorData[2] + "%";
                console.log("SENSOR DATA received [OK]");
                console.log("latestSensorData = " + latestSensorData);
                console.log("writting to blockchain");

                var newState = parseInt(block.State) + 1;

                if(newState == 12) {
                    newState = "COMPLETE";
                }

                var data = {
                    "ID": block.ID,
                    "TimeStamp": timestamp,
                    "State": newState,
                    "Owner": block.Owner,
                    "User": block.User,
                    "TempData": latestSensorData
                };

                console.log(data)            

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };               

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/UpdateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }      
            },
            async ReadAssetHistory(block) {
                var data = {
                    "ID": block.ID,
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                const ReadAssetHistoryURL = "https://mcaloon.org/ReadAssetHistory";

                try {
                    const response = await this.$http.post(
                        ReadAssetHistoryURL,
                        data,
                        {headers: headers}
                    );                

                    // append history to block
                    block.history = response.data;

                    for (var x = 0; x < response.data.length; x++) {
                        if(response.data[x].State == "0") {    
                            block.stage0 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "1") {    
                            block.stage1 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "2") {
                            block.stage2 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "3") {
                            block.stage3 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "4") {
                            block.stage4 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "5") {
                            block.stage5 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "6") {
                            block.stage6 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "7") {
                            block.stage7 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "8") {
                            block.stage8 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "9") {
                            block.stage9 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "10") {
                            block.stage10 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "11") {
                            block.stage11 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "COMPLETE") {
                            block.stage12 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }                        
                    }
                } catch (error) {
                    console.log(error);
                }    
            },
            convertBlockTimestamp: function(timestamp) {
                var ts = new Date(parseInt(timestamp));     
                var tsa = ts.toLocaleString('en-AU').toUpperCase();
                var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                ts = tsb.replace(',', '');
                return ts;
            },
            openNewContractModal: function() {
                // clear contractName
                this.contractName = '';
                this.contractApplication = null;
                this.contractTemplate = null;
            },
            createNewContract: function(){
                console.log('create new contract button clicked!');
                console.log('contract name = ' + this.contractName);
                this.CreateAsset();
            },
            earthClick: function() {
                var currentURL = window.location.href;
                console.log(currentURL);
                window.location.assign(currentURL + "earth");
            },
            pi2DataClick: function() {
                this.playSound("play","Displaying current Temperature and Humidity Sensor readingsfrom the design lab.");

                console.log("pi2DataClick!");

                // fetch data
                this.fetchSensorData = true;

                // hide table show loading spinner 
                document.getElementById("live-data-loading").style.display = 'block';
                document.getElementById("live-data-container").style.display = 'none';
            },
            pi2DataHide: function() {
                // stop data fetch
                this.fetchSensorData = false;
                console.log("pi2DataHide function from parent!");
            },
            openNav: function() {
                console.log("mobile nav opened");
                document.getElementById("mySidenav").style.width = "100%";
                document.getElementById("mobile_nav_items").style.display = "block";
                document.getElementById("mobile_nav_items").classList.remove("animate__fadeOut");
            },
            closeNav: function() {
                console.log("mobile nav closed");
                document.getElementById("mySidenav").style.width = "0%";
                document.getElementById("mobile_nav_items").classList.add("animate__fadeOut");
            },
            clearTable: function() {
                this.sensorData = [];

                this.piData.data.labels = [];
                this.piData.data.datasets[0].data = [];
                this.piData.data.datasets[1].data = [];           
            },
            autoFetch: function () {
                if (this.autofetch) {
                    // turn off auto update
                    this.autofetch = false;
                } else {
                    // turn on auto update
                    this.autofetch = true;      
                    this.getSensorData();
                }
            },
            async getTrackingData() {
                try {
                    let url = "https://2eyqm30671.execute-api.ap-southeast-2.amazonaws.com/beta/lifelink";
                    let headers = {
                        'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                    };

                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    //console.log(response.data.Items);

                    // sort by timestamp
                    response.data.Items.sort(function(x, y){
                        return x.TIMESTAMP - y.TIMESTAMP;
                    })                
                    
                    for(var i = 0; i < response.data.Items.length; i++) {
                        // add row number
                        response.data.Items[i].rowNumber = i + 1;

                        // format timestamp
                        var ts = new Date(parseInt(response.data.Items[i].TIMESTAMP + '000'));
                        response.data.Items[i].formattedTimestamp = ts.toLocaleString('en-AU').toUpperCase();
                        response.data.Items[i].formattedTimestamp = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + response.data.Items[i].formattedTimestamp;
                        response.data.Items[i].formattedTimestamp = response.data.Items[i].formattedTimestamp.replace(',', '');
                        
                        // clean up date (remove any leading or trailing "'")
                        if(response.data.Items[i].CELLID.substr(-1) === "'") {
                            response.data.Items[i].CELLID = response.data.Items[i].CELLID.substr(0, response.data.Items[i].CELLID.length - 1);
                        }
                        if(response.data.Items[i].LAC.substr(-1) === "'") {
                            response.data.Items[i].LAC = response.data.Items[i].LAC.substr(0, response.data.Items[i].LAC.length - 1);
                        }
                        if(response.data.Items[i].MNC.substr(-1) === "'") {
                            response.data.Items[i].MNC = response.data.Items[i].MNC.substr(0, response.data.Items[i].MNC.length - 1);
                        }
                        if(response.data.Items[i].RSSI[0] === "'") {
                            response.data.Items[i].RSSI = response.data.Items[i].RSSI.substr(1);
                        }
                        
                                        
                    }

                    // reverse order
                    response.data.Items = response.data.Items.reverse();   

                    // data for table
                    this.trackingDataAll = response.data.Items;

                    var trackingDataRpi4G = [];
                    var trackingDataRpi4G02 = [];

                    // seperate data
                    for(i = 0; i < this.trackingDataAll.length; i++) {
                        if(this.trackingDataAll[i].ID == 'Rpi-4G') {
                            trackingDataRpi4G.push(this.trackingDataAll[i]);
                        }
                        if(this.trackingDataAll[i].ID == 'Rpi-4G-02') {
                            trackingDataRpi4G02.push(this.trackingDataAll[i]);
                        }                    
                    }

                    this.trackingDataRpi4G = trackingDataRpi4G;
                    this.trackingDataRpi4G02 = trackingDataRpi4G02;

                    // set tab heading
                    this.tabTrackingDataAll = 'All (' + this.trackingDataAll.length + ')';
                    this.tabTrackingDataRpi4G = 'Rpi4G (' + this.trackingDataRpi4G.length + ')';
                    this.tabTrackingDataRpi4G02 = 'Rpi4G-02 (' + this.trackingDataRpi4G02.length + ')';

                    // render map baded on current tab
                    this.trackingTabChanged(localStorage.tab);

                

                } catch (error) {
                    console.log(error);
                }
            },
            async getLocationTest(row) {
                //console.log('test api click');
                // getLocationTest from AddGoogleMap.vue
                this.$refs.googleMaps.getLocationTest(row);
            },
            trackingTabChanged: function(tab) {
                console.log("tab changed to tab " + tab);
                localStorage.tab = tab;

                // set map to latest valid location for selected tab
                if(localStorage.tab == 0) {
                    for(var i = 0; i < this.trackingDataAll.length; i++) {
                        if(this.trackingDataAll[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataAll[i]);
                            break;
                        }
                    }
                }
                if(localStorage.tab == 1) {
                    for(i = 0; i < this.trackingDataRpi4G.length; i++) {
                        if(this.trackingDataRpi4G[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataRpi4G[i]);
                            break;
                        }
                    }
                }
                if(localStorage.tab == 2) {
                    for(i = 0; i < this.trackingDataRpi4G02.length; i++) {
                        if(this.trackingDataRpi4G02[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataRpi4G02[i]);
                            break;
                        }
                    }          
                }                      
                
            },
            async audioPlay(fileName) {
                console.log('start timer');
                var audio = new Audio(this.audioPath + fileName);
                await new Promise(resolve => setTimeout(resolve, 1000));  // 200ms delay
                console.log('after 1sec');
                audio.play();
                this.voiceChangeLoading = false;
                this.voiceTestLoading = false;        
                this.restoreVoiceTestLoading = false;
            },
            async restoneVoiceTest() {
                this.voiceSelected = "Olivia,neural";
                this.voiceLanguageSelected = "en-AU";
                localStorage.voiceSelected = this.voiceSelected;
                localStorage.voiceLanguageSelected = this.voiceLanguageSelected;
                this.getVoices();
                this.restoreVoiceTestLoading = true;
                await this.playSound("play","Default voice Olivia neural restored");
            },
            async changeVoice() {
                localStorage.voiceSelected = this.voiceSelected;
                localStorage.voiceLanguageSelected = this.voiceLanguageSelected;
                this.voiceChangeLoading = true;
                await this.playSound("play","voice changed to " + this.voiceSelected);
            },            
            async voiceTest() {
                this.voiceTestLoading = true;
                await this.playSound("play",this.voiceText, true);
            },
            async playSound(action, voice, test) {
                // only process if enabled
                if(this.AIChecked || action == "off") {
                    if(voice) {
                        //voice = "custom speech";
                    } else {
                        console.log(action);
                        console.log(this.userInfo);

                        // -------------------
                        // Voice logic (test)
                        // -------------------
                        // var firstName = "";
                        // console.log(this.userName);

                        // if(this.userName == "smcaloon"){
                        //     firstName = "Simon";
                        // } else if (this.userName == "smason"){
                        //     firstName = "Scott"
                        // } else {
                        //     firstName = "life chain user"
                        // }

                        if(action == "on") {
                            // // generate greeting
                            // var greetings = [
                            //     "hello " + firstName,
                            //     "hi " + firstName,
                            //     "hey " + firstName,
                            //     firstName + ", it's Nice to see you",
                            //     "Good to see you " + firstName,
                            //     "Great to see you " + firstName,
                            //     firstName + " Long time no see",
                            //     "It's been a while " + firstName,
                            //     "yo " + firstName,
                            //     "whats up",
                            //     "sup",
                            //     "heyyy",
                            //     "hiya",
                            //     "ahoy",
                            //     "hello stranger",
                            //     "goodmorrow",
                            //     "what's cracking",
                            //     "what's up buttercup",
                            //     "howdy",
                            //     "hey mate"
                            // ]

                            // console.log("greetings = " + greetings.length)

                            // var index = parseInt(Math.random() * greetings.length);
                            // console.log("index = " + index);
                            // voice = greetings[index]

                            var hours = new Date().getHours();
                            console.log(hours);

                            var ampm = (hours >= 12) ? "PM" : "AM";
                            console.log(ampm);                        

                            var timeBasedGreeting = ""
                            if(ampm == "AM") {
                                timeBasedGreeting = "Good morning";
                            } else {
                                if(hours >= 18) {
                                    timeBasedGreeting = "Good evening";
                                } else {
                                    timeBasedGreeting = "Good afternoon";
                                }
                            }

                            // greeting - use name       
                            //voice = timeBasedGreeting + " " + firstName;

                            // greeting - introduction
                            voice = timeBasedGreeting;

                            // TEMP FIX for tracking page (which reloads on click - needs to fix, realted to vitrafyEarth intergration)
                            if(localStorage.nav == "tracking") {
                                voice = "displaying current global locations of Life Link devices";
                            }
                        } 
                        if(action == "off") {
                            // // generate farwell
                            // //voice = 'Bye for now';

                            // var farwells = [
                            //     "bye",
                            //     "take it easy",
                            //     "I'm off",
                            //     "see you later",
                            //     "see ya later",
                            //     "bye, bye",
                            //     "goodbye",
                            //     "have a nice day"                            
                            // ]

                            // index = parseInt(Math.random() * farwells.length);
                            // voice = farwells[index];

                            // voice = "Life Chain virtual assistant disabled. Goodbye.";
                            voice = "Goodbye.";
                        }
                    }

                    voice = "<speak>" + voice + "</speak>";

                    // -------------------
                    // Voice logic (test)
                    // -------------------
                    console.log("play sound test");
                    console.log("voiceLanguageSelected = " + this.voiceLanguageSelected);

                    // get voice details from localstorage
                    var voiceSelected = localStorage.voiceSelected;
                    var voiceLanguageSelected = localStorage.voiceLanguageSelected;

                    // if this is a voice test overwrite with values from data model 
                    if(test) {
                        voiceSelected = this.voiceSelected;
                        voiceLanguageSelected = this.voiceLanguageSelected;
                    }

                    var data = {
                        "Engine": voiceSelected.split(",")[1],
                        "LanguageCode": voiceLanguageSelected,
                        "Text": voice,
                        "TextType": 'ssml',
                        "OutputFormat": 'mp3',
                        "VoiceId": voiceSelected.split(",")[0]
                    };

                    data = JSON.stringify(data);

                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                    };            

                    try {
                        const response = await this.$http.post(
                            "https://mcaloon.org/PollyTest",
                            data,
                            {headers: headers}
                        );
                        
                        var x = response.data;
                        console.log(x);

                        this.audioPlay(x);

                        console.log("playing audio...");


                    } catch (error) {
                        console.log(error);
                    }
                }
            },
            async getLatestSensorData() {
                let url = "https://xct6d7fy58.execute-api.ap-southeast-2.amazonaws.com/beta";
                let headers = {
                    'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                };

                try {
                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    console.log("--- sensor data ---")
                    //console.log(response.data)
                    return response.data.Items[0].itemData[29].deviceTempData;

                } catch (error) {
                    console.log(error);
                }
            },
            doSomethingOnHidden: function() {
                console.log("MODAL CLOSED!!!");
            },
            dynamicGreeting: function() {
                // dynamic greeting
                var hours = new Date().getHours();
                console.log(hours);

                var ampm = (hours >= 12) ? "PM" : "AM";
                console.log(ampm);                        

                var userName = "Simon";
                var timeBasedGreeting = ""
                if(ampm == "AM") {
                    timeBasedGreeting = "Good morning";
                } else {
                    if(hours >= 18) {
                        timeBasedGreeting = "Good evening";
                    } else {
                        timeBasedGreeting = "Good afternoon";
                    }
                }
                this.dashboardDynamicGreeting = timeBasedGreeting + " " + userName + " " + "👋";                
            },
            async retrieveBlockchainFromAPI() {
                let items = [];
                let lastEvaluatedKey;
                const blockChainTableName = process.env.VUE_APP_BLOCKCHAIN_DB_TABLE_NAME;
                
                const headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                console.log("Getting ALL items from API...")
                do {
                    let params;
                    
                    // console.log("Looping... LAst evaluated key: ", lastEvaluatedKey)
                    if (!lastEvaluatedKey) params = new URLSearchParams({ TableName: blockChainTableName });
                    else params = new URLSearchParams({
                        TableName: blockChainTableName,
                        ExclusiveStartKey: JSON.stringify(lastEvaluatedKey)
                    });
                    
                    let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                    try {
                        // console.log("Makingr request... URL: ", url, " Headers: ", headers, " Params: ", params);
                        let response = await this.$http.get(url, { headers });
                        
                        // console.log("Items retrieved: ", response.length)
                        items = items.concat(response.data.Items);
                        lastEvaluatedKey = response.data.LastEvaluatedKey;
                    }
                    catch (error) {
                        console.error('Error fetching items:', error);
                        break; // Exit the loop if there's a critical error
                    }
                } while (lastEvaluatedKey);

                // Use the 'items' array for further processing or display in your Vue component
                //console.log('All items retrieved:', items);
                //console.log('All items retrieved (stringified):', JSON.stringify(items));
                console.log('All items retrieved...', );

                // hide main loading screen and show app                
                this.showLoader = false;

                setTimeout(() => {
                    this.pageLoading = false;
                }, 500);                   

                return items;           
            },
            getRandomLoadingText(arr) {
                // Ensure the array is not empty
                if (arr.length === 0) {
                    throw new Error('Array is empty');
                }

                // Get a random index from the array
                const randomIndex = Math.floor(Math.random() * arr.length);

                // Return the element at the random index
                return arr[randomIndex];
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            async checkAPIHeartBeat() {
                console.log("Checking API heartbeat... ", new Date().toUTCString());

                try {
                    const response = await this.$http.get(
                        process.env.VUE_APP_API_HEARTBEAT_URL,
                        { headers: { 'Authorization': 'Bearer ' + localStorage.idtoken } }
                    );
                    if (response) console.log("API Heartbeat OK. Response: ", response.data.message);
                } catch (error) {
                    console.log("error: ", error)
                    if (error.response.status === 401) {
                        console.log("API Heartbeat failed. Redirecting to login page...");
                        this.dismissCountDown = this.dismissSecs;
                        clearInterval(this.sessionExpiredTimer);
                    }
                    else console.log("API Heartbeat failed. Error: ", error);
                }
            },
            async getVirtualDevices() {
                
                this.virtualDevices = [
                    {
                        "deviceTimestamp": 1725926895754,
                        "deviceFreeMem": 3.288502272,
                        "deviceUsedMem": 5.115883519999999,
                        "deviceCPU": 9,
                        "deviceDateTime": "2024-09-10T00:08:15.754Z",
                        "deviceUptime": "19 hours, 20 minutes, 48 seconds",
                        "id": "Vitrafy-00016",
                        "name": "Guardion-00010",
                        "deviceTempData": "",
                        "deviceTotalMem": 8.404385792,
                        "testDevice": false,
                        "sensorDevice": false,
                        "tempAndFlow": {belowZero: true, temp: -42, flow: 10},
                        "details": "Cryopreservation Apparatus",
                        "diff": 10.73,
                        "online": false,
                        "offline": true,
                        "deviceMEM": 60.9,
                        "sensorData": "",
                        "lifeLinkUpToDate": true,
                        "lifelinkVersion": "0.1.1",
                        "location": "Vitrafy Lab",
                        "coords": {
                            "lat": -37.53092219073088,
                            "lng": 143.84338591371284
                        },
                        "convertedTimestamp": "2024-09-10T00:08:15.754Z",
                        "lastCommunicationSeconds": 10,
                        "formattedLastCommunicationSeconds": "10 seconds ago",
                        "registered": true,
                    },
                    {
                        "deviceTimestamp": 1725926895754,
                        "deviceFreeMem": 3.288502272,
                        "deviceUsedMem": 5.115883519999999,
                        "deviceCPU": 9,
                        "deviceDateTime": "2024-09-10T00:08:15.754Z",
                        "deviceUptime": "19 hours, 20 minutes, 48 seconds",
                        "id": "Vitrafy-00015",
                        "name": "Guardion-00011",
                        "deviceTempData": "",
                        "deviceTotalMem": 8.404385792,
                        "testDevice": false,
                        "sensorDevice": false,
                        "tempAndFlow": {belowZero: true, temp: -42, flow: 10},
                        "details": "Cryopreservation Apparatus",
                        "diff": 10.73,
                        "online": true,
                        "offline": false,
                        "deviceMEM": 60.9,
                        "sensorData": "",
                        "lifeLinkUpToDate": false,
                        "lifelinkVersion": "0.1.0",
                        "location": "Vitrafy Lab",
                        "coords": {
                            "lat": -37.53092219073088,
                            "lng": 143.84338591371284
                        },
                        "convertedTimestamp": "2024-09-10T00:08:15.754Z",
                        "lastCommunicationSeconds": 10,
                        "formattedLastCommunicationSeconds": "10 seconds ago",
                        "registered": true,
                    },                    
                    {
                        "deviceTimestamp": new Date().toString(),
                        "utcTimeStamp": new Date().toUTCString(),
                        "lifelinkVersion": "0.2.3",
                        "deviceFreeMem": 5.144584192,
                        "deviceUsedMem": 3.0472232960000003,
                        "deviceCPU": 1.3,
                        "deviceDateTime": "2024-09-10T00:08:25.675Z",
                        "deviceUptime": "38 days, 21 hours, 48 minutes, 4 seconds",
                        "id": "Packaging Device 7",
                        "name": "Packaging Device 7",
                        "deviceTempData": "1725926906 25.8 30.7 0.000000 0.000000 N/A",
                        "deviceTotalMem": 8.191807488,
                        "testDevice": true,
                        "sensorDevice": true,
                        "details": "MIoT Test Device (sensor)",
                        "diff": 0.81,
                        "online": true,
                        "offline": false,
                        "deviceMEM": 37.2,
                        "SensorTemp": "22.9",
                        "SensorRH": "30.7",
                        "sensorData": "22.9C / 30.7%",
                        "sensorDataTimestamp": "1725926906",
                        "sensorTimeDiff": 0,
                        "seconds": 1725926906,
                        "lifeLinkUpToDate": true,
                        "location": "Vitrafy Lab",
                        "coords": {
                            "lat": -37.53092219073088,
                            "lng": 143.84338591371284
                        },
                        "map_zoom_level": 17,
                        "convertedTimestamp": "2024-09-10T00:08:25.675Z",
                        "lastCommunicationSeconds": 3,
                        "formattedLastCommunicationSeconds": "3 seconds ago",
                        "registered": true,
                    },
                    {
                        "deviceTimestamp": new Date().toString(),
                        "utcTimeStamp": new Date().toUTCString(),
                        "lifelinkVersion": "4.1.0",
                        "deviceFreeMem": 5.144584192,
                        "deviceUsedMem": 3.0472232960000003,
                        "deviceCPU": 1.3,
                        "deviceDateTime": "2024-09-10T00:08:25.675Z",
                        "deviceUptime": "38 days, 21 hours, 48 minutes, 4 seconds",
                        "id": "Cell Analyzer-01",
                        "name": "Cell Analyzer-01",
                        "deviceTempData": "1725926906 25.8 30.7 0.000000 0.000000 N/A",
                        "deviceTotalMem": 8.191807488,
                        "testDevice": true,
                        "sensorDevice": true,
                        "details": "Hematology Analyzer Apparatus",
                        "diff": 0.81,
                        "online": true,
                        "offline": false,
                        "deviceMEM": 37.2,
                        "SensorTemp": "22.9",
                        "SensorRH": "30.7",
                        "sensorData": "22.9C / 30.7%",
                        "sensorDataTimestamp": "1725926906",
                        "sensorTimeDiff": 0,
                        "seconds": 1725926906,
                        "lifeLinkUpToDate": true,
                        "location": "Vitrafy Lab",
                        "coords": {
                            "lat": -37.53092219073088,
                            "lng": 143.84338591371284
                        },
                        "map_zoom_level": 17,
                        "convertedTimestamp": "2024-09-10T00:08:25.675Z",
                        "lastCommunicationSeconds": 3,
                        "formattedLastCommunicationSeconds": "3 seconds ago",
                        "registered": true,
                    }                    
                ];
            },
        },
        watch: {
            async dismissCountDown (newValue) {
                // console.log("dismisscountdown value changed to: ", newValue);
                if (newValue <= 0) {
                    console.log("Session expired. Redirecting to login page...");
                    window.location.href = "/";
                }
            },
            AIChecked() {
                //console.log(this.AIChecked);
                if(this.AIChecked) {
                    // turn on text to speech
                    localStorage.assistant = true;
                    // this.$refs.SpeechRecognition.startListen();

                    // console.log("AI Assistant Enabled!");
                    this.playSound("on");

                    // document.getElementById("WACContainer").setAttribute("style","display: block");
                    
                    // document.getElementById("SpeechRecognition").classList.remove("animate__fadeOutDown");
                    // document.getElementById("SpeechRecognition").setAttribute("style","display: block");

                    //this.voiceText = "Hi, my name is Lily. I'm the LifeChain Virtual Assistant. How can I help you today?";
                } else {
                    // turn off text to speech
                    localStorage.assistant = false;
                    // this.$refs.SpeechRecognition.stopListen();
                    // console.log("AI Assistant disabled");
                    this.playSound("off");

                    // document.getElementById("WACContainer").setAttribute("style","display: none !important");

                    // document.getElementById("SpeechRecognition").classList.add("animate__fadeOutDown");
                }
            }
        },
        async created() {
            // set nav to old
            //this.sideNav = this.sideNavHome; //default
            //this.sideNav = this.sideNavLifeLink;
            //this.sideNav = this.sideNavOld;    
            
            // old
            // this.selectedApp = localStorage.getItem('selectedApp');
            // if(this.selectedApp == "Home") {
            //     this.sideNav = this.sideNavHome;
            //     this.sideNavClick("Dashboard");
            // } else if(this.selectedApp == "LifeLink") {
            //     this.sideNav = this.sideNavLifeLink;
            //     this.cardNavClick("LifeLink");
            // } else if(this.selectedApp == "Workflow") {
            //     this.sideNav = this.sideNavOld;     
            //     this.cardNavClick("Human");           
            // } else {
            //     this.sideNav = this.sideNavHome; //default
            //     this.selectedApp = "Home";
            //     this.sideNavClick("Dashboard");
            // }

            const section = (window.location.pathname.split("/")[1] || "home").toLowerCase();    
            this.selectedApp = section      
            if(section == "home") {
                this.sideNav = this.sideNavHome;
                this.sideNavClick("Dashboard");
            } else if(section == "lifelink") {
                this.sideNav = this.sideNavLifeLink;
                this.cardNavClick("LifeLink");
            } else if(section == "workflow") {
                this.sideNav = this.sideNavOld;     
                this.cardNavClick("Human");           
            } else {
                this.sideNav = this.sideNavHome; //default
                this.selectedApp = "home";
                this.sideNavClick("Dashboard");
            }


            // these are all now actioned on click and local stroage state
            // this.getLifeLinkData();
            // this.getSensorData();
            // this.getTrackingData();
            //document.getElementById("WACContainer").setAttribute("style","display: none !important");

            if(this.userInfo.username.split("@")[0] == 'asoysa') window.location.href = "./sensorDashboard";

            // Redirect HuonAquaculture users to the 'AquaCulture Dashboard'
            if (this.userInfo.user_additional_info && this.userInfo.user_additional_info.huon_user) {
                window.location.href = "./aquacultureDashboard";
            } else {
                // Display core vue app element
                const appElement = document.getElementById('app');
                appElement.style.display = 'block';                    
            }
            await this.getRandomLoadingText(this.loadingTextPhrases);
            this.bcCache = await this.retrieveBlockchainFromAPI();
        },
        beforeDestroy(){
            clearInterval(this.timer);
            clearInterval(this.sessionExpiredTimer)
        },
        mounted: async function () {
            // heartbeat to check if user's JWT token is expired
            this.sessionExpiredTimer = setInterval(async () => {
                await this.checkAPIHeartBeat();
            }, 1000 * 60 * 5) // Every 5 minutes

            setTimeout(() => {
                this.loadingImageIsVisible = true;
            }, 100);

            setTimeout(() => {
                this.loadingTextIsVisible = true;
            }, 1000);

            // dynamic loading text
            this.timer = await setInterval(() => {
                this.loadingText = this.getRandomLoadingText(this.loadingTextPhrases);
            }, 3000) // 3 sec              
            
            //console.log("Loaded LifeChain dashboard.")

            if (typeof this.userInfo.username !== 'undefined') {
                this.userName = this.userInfo.username.split("@")[0];
            }

            // if(this.userName == 'smcaloon') {
            //     window.location.href = "http://stackoverflow.com";
            // }

            // Specific Only Machine Learning access for user kjeffrey
            // if(this.userName == "kjeffrey") {
            //     this.sideNav = this.ML_Only_sideNav;
            // }

            // remove nav restrictions if user is not restricted
            if(!this.restrictedLifeLinkUser) {
                for(var i = 0; i < this.sideNav.length; i++) {
                    this.sideNav[i].restricted = false;
                }
            }

            console.log("restrictedLifeLinkUser = " + this.restrictedLifeLinkUser)
            
            // ---------- Initial  fetch data calls ----------
            await this.getAllDevicesFromDB();
            await this.getLifeLinkData();
            await this.getVirtualDevices();
            // ---------- All auto fetch data calls ----------
            // LifeLInk API auto-fetch
            this.timer = await setInterval(() => {
                if(this.fetchDeviceData) {
                    this.getAllDevicesFromDB();
                    this.getLifeLinkData();
                    this.getVirtualDevices();
                    // this.getMachineTempData('Vitrafy-00001');
                    // this.getMachineTempData('Vitrafy-00002');
                    // this.getMachineTempData('Vitrafy-00004');
                    // this.getMachineTempData('Vitrafy-00005');
                    // this.getMachineTempData('Vitrafy-00006');
                    // this.getMachineTempData('Vitrafy-00007');
                    // this.getMachineTempData('Vitrafy-00009');
                    // this.getMachineTempData('Vitrafy-00010');
                    // this.getMachineTempData('Vitrafy-00011');
                    // this.getMachineTempData('Vitrafy-HP00001');
                }
            }, 30000) // 30 sec

            // console.log("All items: ", this.items)

            // dynamic greeting
            // this.timer = setInterval(() => {
            //     this.dynamicGreeting();
            // }, 600000) // 10 min

            // DISABLED.
            // // Tracking Data API auto-fetch
            // this.timer3 = setInterval(() => {
            //     if(this.fetchTrackingData) {
            //         this.getTrackingData();
            //     }
            // }, 60000) // 1 min       
            // ---------- END All auto fetch data calls ---------- 

            // local storage (get/set active page)
            // const nav = localStorage.getItem('nav');
            // if(nav){
            //     this.sideNavClick(nav);
            // }else{
                // this.sideNavClick("Dashboard");
            // }

            // local storage (get/set google maps tracking tab)
            if (localStorage.tab == 1) {
                this.tab = 1;
                localStorage.tab = 1;
            } else if(localStorage.tab == 2){
                this.tab = 2;
                localStorage.tab = 2;
            } else {
                this.tab = 0;
                localStorage.tab = 0;
            }
            
            // check local storage to see if assistant is on
            if(localStorage.assistant == "true") {
                this.AIChecked = true;
            }

            // check local storage for lifeLinkView Selection
            // const lifeLinkView = localStorage.getItem('lifeLinkView');
            // if(lifeLinkView){
            //     this.lifeLinkView = localStorage.lifeLinkView
            // }else{
            //     this.lifeLinkView = "location" //default
            // }

            this.lifeLinkView = "registered" //default

            // load voice settings from localStorage      
            const voiceSelected = localStorage.getItem('voiceSelected');
            if(voiceSelected){
                this.voiceSelected = localStorage.voiceSelected;
            }else{
                // set default
                this.voiceSelected = "Olivia,neural";
                localStorage.voiceSelected  = this.voiceSelected;
            }

            const voiceLanguageSelected = localStorage.getItem('voiceLanguageSelected');
            if(voiceLanguageSelected){
                this.voiceLanguageSelected = localStorage.voiceLanguageSelected
            }else{
                // set default
                this.voiceLanguageSelected = "en-AU";
                localStorage.voiceLanguageSelected = this.voiceLanguageSelected;
            }       

            /* Get Device data from DB */
            this.getAllDevicesFromDB();

            console.log("virtualDevices: ", this.virtualDevices)
            console.log("DEBUG");
            console.log(this.voiceSelected + " " + this.voiceLanguageSelected);

            //this.sideNavClick("Dashboard");
        }
    }
</script>

<style>
    #__BVID__7__BV_toggle_ {
        padding: 0px !important;
    }

    .app-menu {
        top: 9px !important;
        left: 16px !important;
        padding: 8px !important;
    }

    .app-menu .dropdown-item:active,
    .app-menu .dropdown-item:focus,
    .app-menu .dropdown-item:focus-visible {
    background-color: transparent !important;
    color: inherit;
    outline: none !important;
    box-shadow: none !important;
    }

    .dropdown .btn-secondary {
        --bs-btn-border-color: #333 !important;
    }        

    .app-menu-item a {
        position: relative;
        padding: 14px 20px; 
        font-size: 18px !important;
        width: 256px;
        padding-left: 64px;
    }

    /* Remove any background/border/outline that can look like a grey box */
    .app-menu__toggle,
    .app-menu__toggle:hover,
    .app-menu__toggle:focus,
    .app-menu__toggle:focus-visible,
    .app-menu__toggle:active,
    .app-menu__toggle[aria-expanded="true"] {
        background: transparent !important;
        border: 0 !important;
        outline: none !important;
        box-shadow: none !important;
    }

    /* optional: ensure the icon itself never shows a border */
    .app-menu__icon {
        display: block;
        border: 0;
        outline: 0;
    }

    .page-section-hr {
        margin: 0;
        border: 1px solid;
    }

    .page-section-title {
      padding: 13px 0px;
      padding-bottom: 12px;
      margin-bottom: 0 !important;
      font-size: 28px;
    }

    .page-section-title span {    
        font-size: 28px;
    }

    #__BVID__15__BV_toggle_ {
        padding-right: 0px !important;
    }

    #app {
        display: none;
    }

    #page-section-loading {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2000;
        height: 100%;
        width: 100%;;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
    }

    #loading-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    #loading-image {
        height: 100px; /* Adjust the size as needed */
        width: auto;
    }

    #loading-text {
        margin-top: 40px;
        font-size: 14px;
        font-family: Arial, sans-serif;
        color: black;
    }

    /* #lifechain-logo-loading {
        height: 100px;
    }     */

    .fade-in {
        opacity: 0;
        transition: opacity 2s ease-in;
    }

    .fade-in-fast {
        opacity: 0;
        transition: opacity 0.5s ease-in;
    }

    .fade-in.show,
    .fade-in-fast.show {
        opacity: 1;
    }
    
    .fade-out {
        opacity: 1;
        transition: opacity 0.3s ease-out;
    }

    .fade-out.hide {
        opacity: 0;
    }
    
    #page-data-loading {
        text-align: center;
    }

    .sub-item-collapsed {
        border: 1px solid #dedfe0;
        margin-left: 0 !important;
        padding: 7px 0;
    }

    .sub-item-collapsed-last {
        color: red;
        margin-top: -1px !important;
    }    

    .sub-item-collapsed span {
        padding-left: 20px;
        padding-right: 40px;;
    }

    #blockchain-collapsed-sub-items {
        position: absolute;
        top: 0px;
        right: -164px;
        background-color: #f8f9fa;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 4px 0px, rgba(0, 0, 0, 0.14) 0px 3px 3px -2px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px !important;
    }

    #side-nav-container {
        position: relative;
    }

    #side-nav-toggle-container {
        position: absolute;
        top: 70px;
        right: 0;
        font-size: 23px;
        margin-right: 6px;
        color: grey;
    }

    #side-nav-toggle-container:hover {
        cursor: pointer;
        color: #525960 !important;
    }
    
    .side-nav-toggle-collapsed {
        margin-right: 21px !important;
    }

    .nft-notification:hover {
        color: var(--bs-dropdown-link-hover-color);
        background-color: var(--bs-dropdown-link-hover-bg);        
    }

    .data-button {
        background: #fff !important;
    }

    .data-button:hover {
        background: #0d6efd !important;
    }    

    .side-nav-icon {
        display:inline-block; 
        width:40px; 
        text-align: center;
    }    

    .page-content {
        position: relative;
    }

    .process_heading {
        margin-left: -13px;
        color: #6c757d;
        text-transform: uppercase;
        font-size: 12px;        
    }

    .infoBoxText input,
    .infoBoxText select {
        font-size: 0.8rem;
    }

    .in-progres-status {
        color: #0a58ca !important;
    }

    .info_boc_in_progress {
        background-color: #0a58ca !important;
        border: 1px solid #033276 !important;
        box-shadow: 0px 0px 8px 1px #0a58ca !important;
    }

    .inactiveProcess {
        border: 1px solid grey !important;
        color: grey !important;
        background-color: lightgrey !important;
    }

    .infoBoxText {
        color: initial !important;
        font-weight: 400 !important;
        margin-top: 15px;
    }

    .infoBoxLabel,
    .infoBoxChevron {
        color: initial !important;
    }

    .infoBoxChain {
        padding-top: 0px !important;
    }

    .infoBoxImage {
        border: 1px solid #6c757d !important;
    }

    .milestoneS-status {
        color: #198754;
        font-weight: bold;
    }

    .blockchain-info-table {
        max-width:100%; 
        white-space:nowrap;
    }

    .blockchain-info-table td {
        padding-right: 30px !important;
    }    

    .hover {
        cursor: pointer;
    }

    .info_box {
        background-color: #fff;
        margin: 20px;
        height: 70px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 2;
        font-weight: 400;
        color: #0f5132;
        background-color: #d1e7dd;
        border: #198754 1px solid;
    }

    .info_boc_l1 {
        background-color: #4E9C82;
        color: white;        
    }    

    .info_boc_l2 {
        background-color: #8DC4A7; 
    }

    .info_boc_l3 {
        background-color: #DFEAE2;
    }    

    .info_box_icon {
        position: absolute; 
        top: 2px; 
        right: 20px; 
        font-size: 18px;        
        color: initial;
    }

    .completedText,
    .inProgressText {
        font-weight: 400;
        color: initial;
    }

    .contractImageNotActioned {
        filter: grayscale(100%) brightness(90%);
        border: 3px solid #e6ebf1;
    }

    .contractImageInProgress {
        z-index: 4 !important;
        filter: none !important;
        border: 3px solid #0a58ca !important;
        box-shadow: 0px 0px 8px 1px #0a58ca !important;
    }

    .contractImage {
        width: 53px;
        border: 3px solid #00ad5b;
        border-radius: 50%;
        position: absolute;
        left: -37px;
        top: -6px;
        z-index: 99;
    }

    .device-filter-heading {
        margin-bottom: 15px;
    }

    .device-filter-container {
        float: left;
        width: 100%;
        margin-bottom: 15px;
    }

    .sidenav-item {
        margin-left: 28p
    }

    .sidenav-item-collapsed {
        /* margin-left: 10px !important; */
        padding-left: 9px !important;
        padding-right: 0 !important;
    }       

    h1 {
        padding-top: 14px !important;
    }

    #__BVID__8__BV_toggle_ {
        padding-right: 0px;
    }

    #app-title {
        font-weight: 400;
        font-size: 29px;
        padding: 7px;
    }

    p.b-dropdown-text,
    a.dropdown-item {
        font-size: 14px;
    }

    .page-header {
        box-shadow: 0 3px 4px 0 rgb(0 0 0 / 20%), 0 3px 3px -2px rgb(0 0 0 / 14%), 0 1px 8px 0 rgb(0 0 0 / 12%) !important;        
    }

    .header-icons {
        color: #FFF;
        font-size: 22px;
        padding-left: 5px;
    }

    .content-container {
        padding: 10px;
        width: 200px;
        padding-bottom: 0;
    }

    #create-new-contract-button {
        margin: 0px;
    }

    #sidebar-menu {
        width: 280px;
        background-color: #f8f9fa;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 100;
        -webkit-box-shadow: inset -1px 0 0 rgb(0 0 0 / 10%);
        box-shadow: inset -1px 0 0 rgb(0 0 0 / 10%);     
        padding: 0px;
        padding-top: 112px;
        transition: all .1s linear;           
    }

    .sidebar-menu-collapsed {
        width: 62px !important;
        transition: all .1s linear;
    }
    
    #main-content-container {
        float: left;
        padding-left: 306px;
        padding-right: 24px;
        width: 100%;
        transition: all .1s linear;  
    }

    .main-content-container-side-nav-collapsed {
        padding-left: 88px !important;
        transition: all .1s linear;  
    }

    .nav-item {
        color:#525960;
        margin-left: 0px;
        padding: 12px 16px 12px 20px;
    }

    .bc-active {
        background-color: #d6d6d6 !important;
        font-weight: 500 !important;
    }

    .nav-item-label {
        position: absolute;
        white-space: nowrap;
    }

    #blockchain-table .btm-primary {
        margin-top: -36px;
    }

    h1 svg {
        padding-right: 10px;
    }

    nav li {
        padding-bottom: 8px;
        padding-top: 8px;
    }

    nav li svg {
        margin: 0 !important;
        margin-right: 10px !important;
        margin-left: 10px !important;
    }

    /* LIVE RED BLINKING DOT */
    .blinking {
    -webkit-animation: 2s blink ease infinite;
    -moz-animation: 2s blink ease infinite;
    -ms-animation: 2s blink ease infinite;
    -o-animation: 2s blink ease infinite;
    animation: 2s blink ease infinite;
    
    }

    @keyframes blink {
        from, to {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }

    @-moz-keyframes blink {
        from, to {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }

    @-webkit-keyframes blink {
        from, to {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }

    @-ms-keyframes blink {
        from, to {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }

    @-o-keyframes blink {
        from, to {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
    }
    /* END = LIVE RED BLINKING DOT */    

    #data-section {
        display: none;
    }

    .end-of-chain {
        /* height: 41px; */
        float: left;
        width: 100%;
        left: -8px;
        position: absolute;
        bottom: -20px;
        background-color: #ffffff;
        z-index: 99;
        color: #ffffff;
    }

    .modal-footer {
        background-color: #ffffff;
        z-index: 99;        
    }

    .chain {
        padding-top: 30px;
        padding-left: 30px;
        position: relative;
    }

    #main-chain::before {
        position: absolute;
        /* top: 0; */
        left: 19px;
        display: block;
        content: "";
        width: 3px;
        height: 100%;
        background-color: #e6ebf1;
        background-color: #00ad5b;
    }

    .chain-row {
        position: relative;
        min-width: 100%;
        float: left;
        padding-top: 1rem;
        padding-bottom: 1rem;
        min-height: 75px;
    }

    .chain-row-top::before {
        position: relative;
        left: -27px;
        top: -1rem;
        display: block;
        content: "";
        width: 100%;
        height: 1px;
        background-color: #e6ebf1;        
    }

    .chain-row-item::before {
        position: relative;
        left: -12px;
        top: -1rem;
        display: block;
        content: "";
        width: 100%;
        height: 1px;
        background-color: #e6ebf1;        
    }    

    .chain-label {
        float: left;
        padding-left: 40px;
        position: relative;
        width: 100%;
    }

    .chain-label::before {
        position: absolute;
        top: -4px;
        left: -26px;
        display: block;
        content: "";
        width: 32px;
        height: 32px;
        background-color: #e6ebf1;
        background-repeat: no-repeat;
        background-position: center center;
        border: 2px solid #f6f8fa;
        border-radius: 50%;        
    }

    .chain-label-complete:before {
        top: 5px !important;
    }

    .chain-label-complete::before {
        position: absolute;
        top: 5px;
        left: -26px;
        display: block;
        content: "";
        width: 32px;
        height: 32px;
        background-color: rgb(112, 218, 112);
        background-repeat: no-repeat;
        background-position: center center;
        border: 2px solid #a1a1a1;
        border-radius: 50%;        
    }    

    .chain-label-in-progress {
        font-weight: bold;
        color: #0a58ca;
    }

    .chain-label-in-progress::before {
        position: absolute;
        top: 5px;
        left: -26px;
        display: block;
        content: "";
        width: 32px;
        height: 32px;
        background-color: #ffc107;
        background-repeat: no-repeat;
        background-position: center center;
        border: 2px solid #a1a1a1;
        border-radius: 50%;        
    }        

    .chain-label-disabled {
        color: #adb5bd;
        padding-top: 11px;
    }

    .chain-label-link {
        color: white;
    }

    .chain-block {
        border: 3px solid;
        width: 50px;
        height:50px;
        float: left;
        /* background-color: #21ECAE; */
    }

    .chain-block-link {
        border: none;
        /* background-color: initial !important; */
    }

    .chain-link {
        width: 50%;
        height: 100%;
        border-right: 3px solid;       
    }

    .chain-label-complete {
        font-weight: bold;
        color: #198754;
    }

    .chain-complete {
        background-color: #28a745ad;
    }



    .contract-complete {
        background-color: #0080000d;
        color: green;        
    }

    .contract-complete-bold {
        font-weight: bold;
    }    


    .bc-active {
        color:#000000!important;
        background-color: #d9d9d9;
        border-right: 4px solid #21ecae;
        font-weight: 700;;
    }

    nav li.bc-active:hover {
        background-color: #d9d9d9;
    }    

    body {
        font-size: 14px !important;
    }

    .dashboard-heading {
        width: 100%;
    }

    .card-button {
        float: right;
        margin-left: 5px;
    }

    .bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
    }

    .logo-link {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        background-color: inherit !important;
    }

    .logo-link img {
        height: 33px;
        ;
    }

    .card-title {
        margin-bottom: 0px !important;
    }

    #vitrafy-logo {
        margin-left: 11px;
    }

    header span {
        color: white;
        font-size: 25px;
        padding: 11px;
        width: 100%;
    }

    .search {
        width: auto !important;
    }

    .section-container {
        float: left;
        /* width: 80%; */
        margin-bottom: 20px;
        width: 100%;
    }

    .cardEl {
        position: relative;
    }

    .card-container {
        float: left;
        margin-right: 20px;
        margin-bottom: 20px;
        box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
        max-width: 364px !important;
    }

    .img-container, .content-container {
        float: left;
    }

    .card-background {
        background-color: #cccccc !important;
    }

    .online {
        background-color: #68C39F !important;
    }

    .content-container {
        width: 200px;
        padding-bottom: 0px;
        padding-top: 3px !important;
    }

    .content-container a, .content-container button {
        float: right;
    }

    .card-button {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 10px;
    }

    .offline {
        color: #6c757d;
    }


    .main-footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 32px;
        z-index: 999;
        background-color: #212529;
        padding: 0px !important;
    }

    .main-footer span {
        float: right;
        /* font-size: 12px;
        padding: 7px !important; */
        padding-top: 8px !important;
        color: #d9d9d9ff
    }

    .main-footer .container {
        max-width: inherit;
    }

    .logo-link a, .nav-item a {
        text-decoration: none !important;
    }

    nav ul {
        margin-top: 10px;
    }

    nav li {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-left: 10px;
        cursor: pointer;
    }

    nav li:hover {
        background-color: rgb(235, 235, 235);
    }

    nav li a {
        color: #333 !important;
    }

    nav li svg {
        margin: 8px;
        margin-bottom: 11px;
    }

    nav li.active a {
        color: #2470dc !important;
    }

    .API-test {
        float: left;
        width: 100%;
        margin-top: 50px;
    }

    .device-buttons {
        bottom: 6px !important;
        right: 10px !important;
    }

    .card-text {
        margin-bottom: 5px;
    }

    #info-table {
        font-size: 13px;
        margin-bottom: 5px;
        width: 100%
    }

    #info-table td.chart {
        width: 100%;
        padding-left: 10px;
    }

    .whiteTable {
        color: white;
    }

    .action-button {
        margin: 10px;
        float: right;
    }

    .contract-action {
        width: 186px;
    }

    .card-footer {
        padding: 0px !important;
    }

    .card-text {
        margin-bottom: 2px;
    }

    .hide-element {
        display: none !important;
    }

    .sensor-time-info {
        color: #6c757d;
        font-size: 10px;
    }

    #tracking-loading {
        display: none;        
    }

    #blockchain-data-loading,
    #live-data-loading,
    #assistantTestModal-loading,
    #tracking-loading,
    #lifelink-loading,
    #nft-loading,
    #tracking-data-loading,
    #tracking-data-loading-hobart {
        text-align: center;
        margin-top: 200px;        
    }

    #blockchain-data-loading-modal {
        text-align: center;
        margin-top: 150px;        
        margin-bottom: 150px;        
    }    

    /* spinner test */
    .lds-facebook {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-facebook div {
        display: inline-block;
        position: absolute;
        left: 8px;
        width: 16px;
        background: #68c08c;
        animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
    .lds-facebook div:nth-child(1) {
        left: 8px;
        animation-delay: -0.24s;
    }
    .lds-facebook div:nth-child(2) {
        left: 32px;
        animation-delay: -0.12s;
    }
    .lds-facebook div:nth-child(3) {
        left: 56px;
        animation-delay: 0;
    }
    @keyframes lds-facebook {
        0% {
            top: 8px;
            height: 64px;
        }
        50%, 100% {
            top: 24px;
            height: 32px;
        }
    }    
   /* END spinner test */    

    .progress-bar-contract {
        background-color: #28a745ad !important;
    }

    /* mobile side nav */
    #mySidenav {
        z-index: 1000;
    }

    header {
        z-index: 999 !important;
    }

    .sidenav {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0;
        right: 0;
        background-color: #111;
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 60px;
        text-align:center;
    }

    .sidenav a {
        padding-top: 8px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
        transition: 0.3s;
    }

    .sidenav a:hover{
        color: #f1f1f1;
    }

    .sidenav .closebtn {
        position: absolute;
        top: -11px;
        right: 25px;
        font-size: 36px;
        margin-left: 50px;
    }

    @media screen and (max-height: 450px) {
        .sidenav {padding-top: 15px;}
        .sidenav a {font-size: 18px;}
    }

    #mobile-sign-out {
        padding-top: 40px;
    }

    .mobile-nav-active {
        color: white !important;
    }    
    /* END mobile side nav */

    /* lock image background */
    #lock-image {
        height: 100%;
        position: absolute;
        right: 0;
        opacity: 1;
        position: fixed;
        margin-top: 20px;
        
    }

    /* #live-data-table tbody tr:first-child {
        background-color: red;
        -moz-transition: all .2s ease-in;
        -o-transition: all .2s ease-in;
        -webkit-transition: all .2s ease-in;
        transition: all .2s ease-in;
    } */

    .isActive {
        /* width: 100px; */
        /* height: 100px; */
        background-color: white;
        animation-name: example;
        animation-duration: 1s;
    }

    @keyframes example {
        from {background-color: white;}
        to {background-color: rgb(181, 217, 252);}
    }

    .navbar .navbar-toggler {
        top: 0.25rem;
        right: 1rem;
    }

    #vaSwitch-mobile {
        position: absolute; 
        left: 12px;
        bottom: 30px;
        white-space: nowrap;
    }    

    /* wallet */
    .dropdown-menu {
        box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    }
    
    .show .header-icons {
        color: #14E3B0;
    }

    .wallet-container {
        width: 340px;   
        height: 450px;     
    }

    /* Mobile Responsive CSS */
    @media (min-width: 768px) {
        .bd-placeholder-img-lg {
            font-size: 3.5rem;
        }

        #desktop-singout {
            float: right; position: relative
        }
    }

    @media (max-width: 767px) {
        #loading-image {
            width: 100%;
            height: auto;
            padding: 20px;
            padding-left: 41px;
        }     

        #sidebar-menu {
            display: none;
        }

        #main-content-container {
            padding-left: 0px;
            padding-right: 0px;
        }

        .bigTempData {
            font-size: 24px !important;
        }        

        .modal-dialog {
            width: 100% !important;
            margin: 0;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100vh;
            display: flex;
            margin: 0 !important;
        }

        #app-title {
            display: none;
        }

        #desktop-singout {
            padding: 10px;
            position: fixed;
            bottom: 0;
            left: 0;
            padding-bottom: 40px;
            width: 100%;
            background: #212529;
            color: #ffffff;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
            box-sizing: border-box;
            justify-content: space-between;
        }

        .main-nav {
            margin-left: 27%;
        }

        #vaSwitch-desktop {
            display: none;
        }

        #vitrafy-logo {
            display: none;
        }

        #lifechain-logo img {
            cursor: pointer;
            height: 31px !important;
            left: 12px !important;
        }

        span#footer-version {
            padding: 0px !important;
            font-size: 14px !important;
        }

        span#footer-copyright {
            padding: 0px !important;
            font-size: 14px !important;
        }

        #mobile-nav-button {
            right: 0px !important;
        }

        .mobile-nav-item {
            white-space: nowrap;
        }

        header {
            height: 56px;
        }

        .card-container {
            position: relative !important;
            margin-right: 0px !important;
            width: 100% !important;
            max-width: 100% !important;
        }

        .content-container {
            width: calc(100% - 120px) !important;
        }

        .card-background {
            width: auto !important;
        }

        .card-text {
            margin-bottom: 0px;
        }

        .card-button {
            margin: 5px !important;
        }

        .card-img-top {
            width: 120px !important;
        }

        /* .section-container {
            width: 100% !important;
        } */

        #lock-image {
            display: none;
        }

        /* ADD MORE MOBILE CSS ADJUSTMENTS HERE */
    }

    @media (min-width: 768px) {
        .card-background {
            width: 140px !important;
        }

        .card-container {
            width: initial;
        }

        /* .section-container {
            width: 75% !important;
        }*/
    }

.highcharts-credits {
    display: none;
}
</style>